<template>
  <div :class="{'container-manage': !isMenuMiniSize, 'container-manage-thin-menu': isMenuMiniSize}">
    <!-- コピー用 -->
    <input type="hidden" style="opacity: 0 !important;" id="copy-code" :value="singleURL"/>
    <!-- ヘッダー -->
    <div class="header-box">
      <div class="header-menu">
        <p><b style="font-size:28px; font-weight: 800;">Data</b></p>
        <p style="margin-left: 25px; font-size:16px; color: #666; margin-top: 8px;">応募者管理画面</p>
      </div>
      <div class="header-menu">
        <b-tooltip label="ショートメッセージ／Ｅメール送信履歴" position="is-bottom">
          <button v-if="isUserAdmin" @click="openSendHistory" :disabled="notAllowSeekerInfo" class="button is-rounded history-button">
            <span class="mdi mdi-send icon-margin"></span>送信履歴
          </button>
        </b-tooltip>
      </div>
    </div>
    <!-- 右メニュー時：バックグラウンド -->
    <div class="background-menu" @click="closeRightMenu()" v-if="isOpenRightMenu"></div>
    <!-- 自動連動設定 -->
    <transition name="right">
      <div class="auto-setting-box disp-scroll" style="position: absolute; top: 0; right: 0; height: 100%; width: 40%; min-width: 400px; background: #FEFEFE; padding: 16px; z-index: 201;" v-if="isOpenCloudSync">
        <h2 style="margin-bottom: 8px; font-weight: 600;"><span class="mdi mdi-cloud-sync" style="margin-right: 8px;"></span>外部媒体連携設定</h2>
        <!-- 媒体連携項目設定モーダル表示ボタン -->
        <button :disabled="displaycompanyRecruit.length <= 0" @click="openModal('mediaCooperationItemMaster')">媒体連携項目マスター設定</button>
        <div v-if="displaycompanyRecruit.length > 0">
          <div style="margin-bottom: 24px;" v-for="(c, idx) in displaycompanyRecruit" :key="idx + '-comrec'">
            <p style="text-align: left; font-weight: 600; margin-bottom: 16px;">編集</p>
            <div style="display: flex; align-items: center; margin-bottom: 8px;">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">連動媒体</p>
              <v-select style="width: calc(100% - 110px); font-size: 13.33px;"
                v-model="c.type"
                :options="sortedFilteredRecruitList"
                label="name" :reduce="rec => rec.type"
                :components="{Deselect: {render: createElement => createElement('span', '')}}"></v-select>
            </div>
            <!-- ログインURL -->
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type===41 || c.type===42 || c.type===43 || c.type===61">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">ログインURL</p>
              <input placeholder="https://url.com" style="width: calc(100% - 110px);" class="input is-small" v-model="c.url"/>
            </div>
            <!-- 独自ドメイン -->
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type===14 || c.type===30 || c.type===62 || c.type===71">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">ドメイン</p>
              <input placeholder="https://url.com" style="width: calc(100% - 110px);" class="input is-small" v-model="c.url"/>
            </div>
            <!-- 企業アカウントID -->
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type===7">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">アカウントID</p>
              <input placeholder="ID1234" style="width: calc(100% - 110px);" class="input is-small" v-model="c.rec_account_id"/>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type===34">
              <!-- riksakのログインURLやAPI要求時に含まれる企業ごとのID -->
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">リクナビ企業ID</p>
              <input placeholder="リクナビ企業ID" style="width: calc(100% - 110px);" class="input is-small" v-model="c.rec_account_id"/>
            </div>
            <!-- ログインIDまたはメールアドレス -->
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type !== 51 && c.type !== 61 && c.type !== 64 && c.type !== 999">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">ログインID</p>
              <input placeholder="ID1234" style="width: calc(100% - 110px);" class="input is-small" v-model="c.rec_id"/>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type === 51">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">メールアドレス</p>
              <input placeholder="indeed@hr-monster.io" style="width: calc(100% - 110px);" class="input is-small" v-model="c.rec_id"/>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type === 61">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">メールアドレス</p>
              <input placeholder="RecruitingCloudd@hr-monster.io" style="width: calc(100% - 110px);" class="input is-small" v-model="c.rec_id"/>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type === 64">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">メールアドレス</p>
              <input placeholder="careerticket@hr-monster.io" style="width: calc(100% - 110px);" class="input is-small" v-model="c.rec_id"/>
            </div>
            <!-- パスワード -->
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type !== 51 && c.type !== 999">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">ログインPW</p>
              <input placeholder="PW1234" type="password" style="width: calc(100% - 110px);" class="input is-small" v-model="c.rec_password"/>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type === 51">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">パスワード</p>
              <input placeholder="PW1234" type="password" style="width: calc(100% - 110px);" class="input is-small" v-model="c.rec_password"/>
            </div>
            <!-- 企業IDや卒業年など、ログイン後に遷移先を指定する情報 -->
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type===12 || c.type===56 || c.type===48">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">企業ID</p>
              <input placeholder="企業ID" style="width: calc(100% - 110px);" class="input is-small" v-model="c.cp_name"/>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type===30">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">部署名</p>
              <input placeholder="部署名" style="width: calc(100% - 110px);" class="input is-small" v-model="c.cp_name"/>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type===61">
              <!-- RecruitingCloud用の認証メール受け取り用のパスワード -->
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">認証メールPW</p>
              <input placeholder="認証メールPW" type="password" style="width: calc(100% - 110px);" class="input is-small" v-model="c.rec_account_id"/>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type===36 || c.type===64 || c.type===67">
              <!-- TODO: riksakで卒業年を使う予定 -->
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">卒業年</p>
              <select class="select"
              v-model="c.cp_name"
              size="is-small"
              >
                <option v-for="(yearlist, index) in setGradiationYear"
                :key="index"
                :value="yearlist">
                  {{ yearlist }}
                </option>
              </select>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="c.type!==999">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">更新間隔</p>
              <select
                class="select"
                size="is-small"
                v-model="c.update_frequency"
              >
                <option value=30>30分</option>
                <option value=60>60分</option>
              </select>
              <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-if="c.type===6">※最新の30件を取得します。</p>
              <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-if="c.type===8">※実際の反映には1時間程度かかる場合があります。</p>
              <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===9">※未対応と対応中のそれぞれ最新50件が取得されます。</p>
              <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===12">※バイトルサイトに登録している企業IDを登録してください。</p>
              <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===14">※ドメインには「https://&lt;ドメイン&gt;/recruiter/loginForm」のドメイン部分を入力してください。</p>
              <p style="width: 100%; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===30">※ドメインには「https://&lt;ドメイン&gt;/saiyou_admin」のドメイン部分を入力してください。<br>※部署名未入力の場合は、全部署の応募者情報を取得します。<br>※エントリー前の候補者は取込から除外されます。</p>
              <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===31">※最大、過去1年分を取得します。</p>
              <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===34">※リクナビより付与されているリクナビ企業IDを登録してください。</p>
              <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===36">※応募者の卒業年(西暦)を登録してください。</p>
              <p style="width: 400px; text-align: left; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===51">※連携には専用のアカウント発行をしております。<br>　発行をご希望の際は、ご案内をさせていただきたく、<br>　お手数ですが、サクセスサポートへお問い合わせください。<br>　support@hr-monster.io</p>
              <p style="width: 400px; text-align: left; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===56">※管理する企業が複数ある場合、企業IDを入力してください。<br>　1社のみの場合は入力不要です。</p>
              <p style="width: 400px; text-align: left; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===61">※連携には弊社のアカウント発行をお願いしております。<br>　連携をご希望の際は、ご案内をさせていただきたく、<br>　お手数ですが、サクセスサポートへお問い合わせください。<br>　support@hr-monster.io</p>
              <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===62">※ドメインには「https://&lt;ドメイン&gt;.recruitsite.net/company/login」のドメイン部分を入力してください。</p>
              <p style="width: 400px; text-align: left; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===64">※応募者の卒業年(西暦)を登録してください。<br><br>※連携には弊社のアカウント発行をお願いしております。<br>　連携をご希望の際は、ご案内をさせていただきたく、<br>　お手数ですが、サクセスサポートへお問い合わせください。<br>　support@hr-monster.io</p>
              <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===67">※応募者の卒業年(西暦)を登録してください。</p>
              <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="c.type===71">※ドメインには「https://&lt;ドメイン&gt;/admin/login.php」のドメイン部分を入力してください。<br><br>※連携には弊社のアカウント発行をお願いしております。<br>　連携をご希望の際は、ご案内をさせていただきたく、<br>　お手数ですが、サクセスサポートへお問い合わせください。<br>　support@hr-monster.io</p>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="select_manages.length > 0">
              <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">応募情報<br>割り振り先</p>
              <v-select
                v-model="c.manage_id"
                :options="select_manages"
                label="name"
                :reduce="name => name.pk"
                multiple>
              </v-select>
            </div>
            <div style="display: flex; justify-content: center; margin-bottom: 8px;">
              <div class="message-frame" v-if="c.is_error === true">
                <p class="error-notice">下記エラーが発生しております。</p>
                <p class="message-text">{{c.message}}</p>
              </div>
              <div class="message-frame" v-if="c.is_error === false && c.message">
                <p class="message-notice">お知らせ</p>
                <p class="message-text">{{c.message}}</p>
              </div>
            </div>
            <div style="display: flex; justify-content: center; margin-bottom: 32px;">
              <button style="margin-right: 16px;" class="button is-small" @click="updateCompanyRecruit(c)">変更する</button>
              <button class="button is-small is-danger" @click="deleteCompanyRecruit(c.pk)">削除する</button>
            </div>
            <div class="dot-line"></div>
          </div>
        </div>
        <div>
          <p style="text-align: left; font-weight: 600;">新規</p>
          <p style="text-align: left; margin-bottom: 16px; font-size: smaller; color: #666;">外部媒体の応募者をHRモンスター上で管理することができます。</p>
          <div style="display: flex; align-items: center; margin-bottom: 8px;">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">連動媒体</p>
            <v-select style="width: calc(100% - 110px); font-size: 13.33px;"
              v-model="tempCompanyRecruit.type"
              :options="sortedFilteredRecruitList"
              label="name" :reduce="rec => rec.type"
              :components="{Deselect: {render: createElement => createElement('span', '')}}"></v-select>
          </div>
          <!-- ログインURL -->
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type===41 || tempCompanyRecruit.type===42 || tempCompanyRecruit.type===43 || tempCompanyRecruit.type===61">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">ログインURL</p>
            <input placeholder="https://url.com" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.url"/>
          </div>
          <!-- 独自ドメイン -->
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type===14 || tempCompanyRecruit.type===30 || tempCompanyRecruit.type===62 || tempCompanyRecruit.type===71">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">ドメイン</p>
            <input placeholder="https://url.com" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.url"/>
          </div>
          <!-- 企業アカウントID -->
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type===7">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">アカウントID</p>
            <input placeholder="ID1234" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.rec_account_id"/>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type===34">
            <!-- riksakのログインURLやAPI要求時に含まれる企業ごとのID -->
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">リクナビ企業ID</p>
            <input placeholder="リクナビ企業ID" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.rec_account_id"/>
          </div>
          <!-- ログインIDまたはメールアドレス -->
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type !== 51 && tempCompanyRecruit.type !== 61 && tempCompanyRecruit.type !== 64&& tempCompanyRecruit.type !== 999">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">ログインID</p>
            <input placeholder="ID1234" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.rec_id"/>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type === 51">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">メールアドレス</p>
            <input placeholder="indeed@hr-monster.io" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.rec_id"/>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type === 61">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">メールアドレス</p>
            <input placeholder="RecruitingCloud@hr-monster.io" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.rec_id"/>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type === 64">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">メールアドレス</p>
            <input placeholder="careerticket@hr-monster.io" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.rec_id"/>
          </div>
          <!-- パスワード -->
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type !== 51 && tempCompanyRecruit.type !== 999">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">ログインPW</p>
            <input placeholder="PW1234" type="password" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.rec_password"/>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type === 51">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">パスワード</p>
            <input placeholder="PW1234" type="password" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.rec_password"/>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type===61">
            <!-- RecruitingCloud用の認証メール受け取り用のパスワード -->
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">認証メールPW</p>
            <input placeholder="認証メールPW" type="password" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.rec_account_id"/>
          </div>
          <!-- 企業IDや卒業年など、ログイン後に遷移先を指定する情報 -->
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type===12 || tempCompanyRecruit.type===56 || tempCompanyRecruit.type===48">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">企業ID</p>
            <input placeholder="企業ID" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.cp_name"/>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type===30">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">部署名</p>
            <input placeholder="部署名" style="width: calc(100% - 110px);" class="input is-small" v-model="tempCompanyRecruit.cp_name"/>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="tempCompanyRecruit.type===36 || tempCompanyRecruit.type===64 || tempCompanyRecruit.type===67">
            <!-- TODO: riksakで卒業年を使う予定 -->
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">卒業年</p>
            <select class="select"
              v-model="tempCompanyRecruit.cp_name"
              size="is-small">
              <option v-for="(yearlist, index) in setGradiationYear"
              :key="index"
              :value="yearlist">
                {{ yearlist }}
              </option>
            </select>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;"v-if="tempCompanyRecruit.type !== 999">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">更新間隔</p>
            <select
              class="select"
              size="is-small"
              v-model="tempCompanyRecruit.update_frequency"
            >
              <option value=30>30分</option>
              <option value=60 selected>60分</option>
            </select>
            <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-if="tempCompanyRecruit.type===6">※最新の30件を取得します。</p>
            <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-if="tempCompanyRecruit.type===8">※実際の反映には1時間程度かかる場合があります。</p>
            <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===9">※未対応と対応中のそれぞれ最新50件が取得されます。</p>
            <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===12">※バイトルサイトに登録している企業IDを登録してください。</p>
            <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===14">※ドメインには「https://&lt;ドメイン&gt;/recruiter/loginForm」のドメイン部分を入力してください。</p>
            <p style="width: 100%; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===30">※ドメインには「https://&lt;ドメイン&gt;/saiyou_admin」のドメイン部分を入力してください。<br>※部署名未入力の場合は、全部署の応募者情報を取得します。<br>※エントリー前の候補者は取込から除外されます。</p>
            <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===31">※最大、過去1年分を取得します。</p>
            <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===34">※リクナビより付与されているリクナビ企業IDを登録してください。</p>
            <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===36">※応募者の卒業年(西暦)を登録してください。</p>
            <p style="width: 400px; text-align: left; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===51">※連携には専用のアカウント発行をしております。<br>　発行をご希望の際は、ご案内をさせていただきたく、<br>　お手数ですが、サクセスサポートへお問い合わせください。<br>　support@hr-monster.io</p>
            <p style="width: 400px; text-align: left; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===56">※管理する企業が複数ある場合、企業IDを入力してください。<br>　1社のみの場合は入力不要です。</p>
            <p style="width: 400px; text-align: left; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===61">※連携には弊社のアカウント発行をお願いしております。<br>　連携をご希望の際は、ご案内をさせていただきたく、<br>　お手数ですが、サクセスサポートへお問い合わせください。<br>　support@hr-monster.io</p>
            <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===62">※ドメインには「https://&lt;ドメイン&gt;.recruitsite.net/company/login」のドメイン部分を入力してください。</p>
            <p style="width: 400px; text-align: left; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===64">※応募者の卒業年(西暦)を登録してください。<br><br>※連携には弊社のアカウント発行をお願いしております。<br>　連携をご希望の際は、ご案内をさせていただきたく、<br>　お手数ですが、サクセスサポートへお問い合わせください。<br>　support@hr-monster.io</p>
            <p style="width: 400px; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===67">※応募者の卒業年(西暦)を登録してください。</p>
            <p style="width: 100%; text-align: centor; padding-left: 24px; font-size: smaller; color: #666;" v-else-if="tempCompanyRecruit.type===71">※ドメインには「https://&lt;ドメイン&gt;/admin/login.php」のドメイン部分を入力してください。<br><br>※連携には弊社のアカウント発行をお願いしております。<br>　連携をご希望の際は、ご案内をさせていただきたく、<br>　お手数ですが、サクセスサポートへお問い合わせください。<br>　support@hr-monster.io</p>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 8px;" v-if="select_manages.length > 0">
            <p style="width: 110px; text-align: left; font-size: smaller; font-weight: 600;">応募情報<br>割り振り先</p>
            <v-select
              v-model="tempCompanyRecruit.manage_id"
              :options="select_manages"
              label="name"
              :reduce="name => name.pk"
              multiple>
            </v-select>
          </div>
          <button class="button is-small is-primary" @click="createCompanyRecruit(tempCompanyRecruit)">登録する</button>
        </div>
        <br><p style="text-align: left; font-size: smaller" v-if="select_manages.length > 0">  ※「応募者一覧」は全応募者が自動で割り振られます。</p>
      </div>
    </transition>
    <!-- テーブル設定 -->
    <TableSetting
      :tempCompanyColumnSetting="tempCompanyColumnSetting"
      :isOpenTableSettingMenu="isOpenTableSettingMenu"
      :isSelectionOptionsModalOpen="isSelectionOptionsModalOpen"
      :columnId="selectedColumnId"
      :columnName="selectedColumnName"
      @update-company-column-setting="updateCompanyColumnSetting"
      @create-company-column-setting="createCompanyColumnSetting"
      @delete-company-column-setting="deleteCompanyColumnSetting"
      @save-column-order="saveColumnOrderTableSetting"
      @open-selection-modal="openSelectionOptionsModal"
      @close-selection-modal="closeSelectionOptionsModal"
      @save-selection-options="saveSelectionOptions"
      @save-option-order="saveOptionOrder"
    />
    <!-- 選択オプションモーダル -->
    <SelectionOptionsModal
      v-if="isSelectionOptionsModalOpen"
      :isSelectionOptionsModalOpen="isSelectionOptionsModalOpen"
      :columnId="selectedColumnId"
      :columnName="selectedColumnName"
      @save-option-order="saveOptionOrder"
      @save="saveSelectionOptions"
      @close="closeSelectionOptionsModal"
    />
    <!-- 詳細シート設定 -->
    <DetailSheetSetting :isOpened="isOpenDetailSheetSetting"/>
    <!-- メールテンプレート -->
    <EmailTemplate
      :isOpenTemplateMenu="isOpenTemplateMenu"
      :chatbots="chatbots"
      :recordingInterviews="recordingInterviews"
      :users="users"
      :user="user"
      :options="options"
      :emailTemplates="emailTemplates"
      :SMSTemplates="SMSTemplates"
      :createCompanyEmailTemplate="createCompanyEmailTemplate"
      :updateCompanyEmailTemplate="updateCompanyEmailTemplate"
      :deleteCompanyEmailTemplate="deleteCompanyEmailTemplate"
      :createCompanySMSTemplate="createCompanySMSTemplate"
      :updateCompanySMSTemplate="updateCompanySMSTemplate"
      :deleteCompanySMSTemplate="deleteCompanySMSTemplate"
      :copyLink="copyLink"
      :PCTRLLOG="CTRLLOG"
      :saveColumnOrder="saveColumnOrderEmailTemplate"
    />
    <!-- メールアクション -->
    <MailAction
      :isOpenEmailMenu="isOpenEmailMenu"
      :isOpenUpdateManageMenu="isOpenUpdateManageMenu"
      :bulk="bulk"
      :chatbots="chatbots"
      :recordingInterviews="recordingInterviews"
      :users="users"
      :options="options"
      :sendLoadding="sendLoadding"
      :emailTemplates="emailTemplates"
      :sendEmailTemplate="sendEmailTemplate"
      :changeEmailTemplate="changeEmailTemplate"
      :sendEmailToSeeker="sendEmailToSeeker"
      :copyLink="copyLink"
    />

    <!-- SMSアクション -->
    <SMSAction
      :isOpenSMSMenu="isOpenSMSMenu"
      :bulk="bulk"
      :chatbots="chatbots"
      :recordingInterviews="recordingInterviews"
      :users="users"
      :options="options"
      :sendLoadding="sendLoadding"
      :SMSTemplates="SMSTemplates"
      :sendSMSTemplate="sendSMSTemplate"
      :changeSMSTemplate="changeSMSTemplate"
      :sendSMSToSeeker="sendSMSToSeeker"
      :copyLink="copyLink"
    />
    <!-- メッセージアクション -->
    <transition name="right">
      <div style="position: absolute; top: 0; right: 0; height: 100%; width: 40%; min-width: 400px; background: #FEFEFE; padding: 16px; z-index: 201;" v-if="isOpenMessageMenu">
        <h2 style="margin-bottom: 8px; font-weight: 600;"><span class="mdi mdi-message" style="margin-right: 8px;"></span>メッセージ</h2>
        <!-- 切替 -->
        <div style="display: flex; flex-wrap: wrap; align-items: center; margin-bottom: 8px; font-weight: 600; height: 100%; width: 100%;">
          <div class="scroll-box" @scroll="loadMessage" :class="{'talk-box': user.permission !== 2, 'watch-box': user.permission === 2}" v-if="chatLogs.length!==0">
            <div class="mdi mdi-loading mdi-spin mdi-48px" v-if="isGetMessageMax"></div>
              <draggable v-model="action" :options="{animation: 250, group: 'CHAT', handle: '.item-handle'}">
                <div>
                  <Balloon
                    v-for="(chat, index) in chatLogs" :key="index + '-chat'"
                    :id="'scrollto-' + index"
                    :speaker="chat.speaker"
                    :name="chat.name"
                    :icon="chat.icon"
                    :message="chat.message"
                    :time="displayDate(chat)"
                    :readTime="new Date()"
                    :isBot="chat.isBot"
                    :email="chat.email"
                    :isManager="chat.isManager"
                    :files="chat.files"
                    :filename="chat.filename"
                    :status="chat.status"
                    :parameter="chat.parameter">
                  </Balloon>
                </div>
              </draggable>
            <div style="height: 10vh; width: 10vw;"></div>
            <div class="loading is-typing"><span v-for="(m, i) in getTyping()" :key="i + '-msg'">{{ m }}</span></div>
          </div>
          <InputForm></InputForm>
        </div>
      </div>
    </transition>
    <!-- 応募者管理画面追加 -->
    <transition name="right">
      <div
        style="position: absolute; top: 0; right: 0; height: 100%; width: 50%; max-width: 500px; background: #FEFEFE; padding: 16px; z-index: 201;"
        v-if="isOpenCreateManageMenu"
      >
        <h2 style="margin-bottom: 8px; font-weight: 600;">
          <span class="mdi mdi-chart-timeline" style="margin-right: 8px;"></span>応募者管理画面追加
        </h2>
        <div style="margin-bottom: 8px; font-weight: 600; height: 100%; width: 100%; text-align: left;">
          <div style="margin-top: 16px; margin-bottom: 8px; font-weight: 600;">
            <span class="mdi mdi-chevron-right-box-outline" style="margin-right: 4px;"></span>追加する応募者管理画面名
          </div>
          <template>
            <div style="display: flex; margin-bottom: 8px;">
              <input class="input is-small" style="width: calc(100% - 56px); border-radius: 0;" maxlength="8" placeholder="応募者管理画面名を入力してください" v-model="createNameManage"/>
              <button class="button is-small is-primary" style="width: 56px; border-radius: 0;" @click="createManage()" :disabled="!createNameManage">+ 追加</button>
            </div>
            <p style="font-size: smaller">  ※追加できる応募者管理画面は最大5つです。</p>
            <p style="font-size: smaller">  ※入力できる文字数は最大8文字です。</p>
            <p style="font-size: smaller">  ※既存の応募者管理画面と同じ名称は使うことができません。</p>
          </template>
        </div>
      </div>
    </transition>
    <!-- 応募者管理画面一括振り分け -->
    <transition name="right">
      <div
        style="position: absolute; top: 0; right: 0; height: 100%; width: 50%; max-width: 500px; background: #FEFEFE; padding: 16px; z-index: 201;"
        v-if="isOpenUpdateManageMenu"
      >
        <h2 style="margin-bottom: 8px; font-weight: 600;">
          <span class="mdi mdi-chart-timeline" style="margin-right: 8px;"></span>応募者管理画面一括振り分け
        </h2>
        <div style="margin-bottom: 8px; font-weight: 600; height: 100%; width: 100%; text-align: left;">
          <div style="margin-top: 16px; margin-bottom: 8px; font-weight: 600;" v-if="!isSeekerLoading">
            <span class="mdi mdi-chevron-right-box-outline" style="margin-right: 4px;"></span>振り分け先を選択してください。
            <p style="font-size: smaller">  ※「応募者一覧」は全応募者が表示されます。</p>
          </div>
          <div v-else><span class="mdi mdi-loading mdi-spin"></span></div>
          <v-select
            v-model="updateManage"
            :options="select_manages"
            label="name"
            :reduce="name => name.pk"
            multiple>
          </v-select>
          <button class="button is-primary" @click="bulkManageSave">
            変更する
          </button>
        </div>
      </div>
    </transition>
    <!-- 採用フロー + アクション -->
    <transition name="right">
      <div
        style="position: absolute; top: 0; right: 0; height: 100%; width: 50%; max-width: 500px; background: #FEFEFE; padding: 16px; z-index: 201;"
        v-if="isOpenFlowMenu"
      >
        <h2 style="margin-bottom: 8px; font-weight: 600;">
          <span class="mdi mdi-chart-timeline" style="margin-right: 8px;"></span>採用フロー設定
          <template v-if="!selectAction && !selectStatus && selectStage"> [ステージ]</template>
          <template v-if="!selectStage  && !selectAction && selectStatus"> [ステータス]</template>
          <template v-if="!selectStatus && !selectStage  && selectAction"> [アクション]</template>
        </h2>
        <!-- 採用フロー / アクション / 詳細の遷移 -->
        <div style="margin-bottom: 8px; font-weight: 600; height: 100%; width: 100%; text-align: left;">
          <!-- パンくずリスト -->
          <div style="margin-top: 16px; margin-bottom: 8px; font-weight: 600;">
            <a style="margin-right: 4px;" @click="selectStage=null;selectStatus=null;selectAction=null;">
              <span class="mdi mdi-chevron-right-box-outline" style="margin-right: 4px;"></span>採用フロー
            </a>
            <a style="margin-right: 4px;" @click="selectStatus=null;selectAction=null;" v-if="selectStage">
              / <span class="mdi mdi-bookmark" style="margin-right: 4px;"></span>{{selectStage.name}}
            </a>
            <a style="margin-right: 4px;" @click="selectAction=null;" v-if="selectStatus">
              / <span class="mdi mdi-chart-scatterplot-hexbin" style="margin-right: 4px;"></span>{{selectStatus.name}}
            </a>
            <a style="margin-right: 4px;" @click="selectAction=null;" v-if="selectAction">
              / <span class="mdi mdi-email-variant" style="margin-right: 4px;"></span>{{selectAction.name}}
            </a>
          </div>
          <!-- 設定済 -->
          <template v-if="recruitmentFlows.length > 0">
            <template v-if="!selectStage&&!selectStatus&&!selectAction">
              <div style="display: flex; margin-bottom: 8px;">
                <input class="input is-small" style="width: calc(100% - 126px); border-radius: 0;" placeholder="ステージ名" v-model="createNameRecruitmentFlowStage"/>
                <input type="color" style="width: 50px; margin: auto 10px;" v-model="createColorRecruitmentFlowStage"/>
                <button class="button is-small is-primary" style="width: 56px; border-radius: 0;" @click="createRecruitmentFlowStage()" :disabled="!createNameRecruitmentFlowStage">+ 追加</button>
              </div>
              <draggable
                class="scrollable disp-scroll"
                v-model="recruitmentFlows[0].stages"
                @end="updateupdateRecruitmentFlowStageRoopDate(recruitmentFlows[0].stages)"
                :options="{animation: 300, group: 'sortByStages', handle: '.drag-button'}"
                style="height: calc(100% - 110px);"
              >
                <div style="display: flex; align-items: center;" v-for="(rfstg, idx) in sortByStages" :key="idx + '-rfstg'">
                  <template v-if="!rfstg.is_delete_apply">
                    <button class="drag-button trans-btn" style="cursor: grabbing;"><span class="mdi mdi-drag mdi-24px"></span></button>
                    <button class="button" @click="selectStage=rfstg" style="display: block; justify-content: flex-start; text-align: left; margin-top: 8px; margin-bottom: 8px; height: 56px; width: 100%; border: solid 2px #faa; border-radius: 0; padding: 0 12px;">
                      <div style="display: flex;">
                        <div style="display: flex; flex-direction: column;">
                          <div style="display: flex;">
                            <span class="mdi mdi-square" style="margin-right: 2px;" :style="{ color: rfstg.color }" />
                            <p>{{rfstg.name}}</p>
                          </div>
                          <p style="font-size: smaller; color: #666;">ステータスの数：{{rfstg.status.length}}件</p>
                        </div>
                        <div style="display: flex; flex-direction: row; margin: auto 0 auto auto; align-items: center;" >
                          <input type="color" style="width: 40px;" :value="rfstg.color ? rfstg.color : '#ffffff'" @input="event => rfstg.color = event.target.value" @click="handleInputClick" @blur="onColorChangeStage(rfstg, $event)"/>
                        </div>
                      </div>
                    </button>
                    <button class="button is-danger" @click="logicalDeleteRfstg(rfstg)" style="display: block; margin-top: 8px; margin-bottom: 8px; margin-left: 8px; height: 56px; width: 56px; border-radius: 0;">
                      <span class="mdi mdi-delete"></span><br/>
                      <p style="font-size: smaller;">削除</p>
                    </button>
                  </template>
                </div>
              </draggable>
            </template>
            <template v-if="selectStage&&!selectStatus&&!selectAction">
              <div style="display: flex; margin-bottom: 8px;">
                <input class="input is-small" style="width: calc(100% - 126px); border-radius: 0;" placeholder="ステータス名" v-model="createNameRecruitmentFlowStatus"/>
                <input type="color" style="width: 50px; margin: auto 10px;" v-model="createColorRecruitmentFlowStatus"/>
                <button class="button is-small is-primary" style="width: 56px; border-radius: 0;" @click="createRecruitmentFlowStatus()" :disabled="!createNameRecruitmentFlowStatus">+ 追加</button>
              </div>
              <div class="scrollable disp-scroll" style="height: calc(100% - 110px);">
                <div style="display: flex;" v-for="(rfsts, idx) in selectStage.status" :key="idx + '-rfsts'">
                  <template v-if="!rfsts.is_delete_apply">
                    <button class="button" style="display: block; text-align: left; margin-top: 8px; margin-bottom: 8px; height: 56px; width: 100%; border: solid 2px #9e9; border-radius: 0; padding: 0 12px;" @click="selectStatus=rfsts">
                      <div style="display: flex;">
                        <div style="display: flex; flex-direction: column;">
                          <div style="display: flex;">
                            <span class="mdi mdi-square" style="margin-right: 2px;" :style="{ color: rfsts.color }" />
                            <p>{{rfsts.name}}</p>
                          </div>
                          <p style="font-size: smaller; color: #666;">アクションの数：{{rfsts.actions.length}}件</p>
                        </div>
                        <div style="display: flex; flex-direction: row; margin: auto 0 auto auto; align-items: center;" >
                          <input type="color" style="width: 40px;" :value="rfsts.color ? rfsts.color : '#ffffff'" @input="event => rfsts.color = event.target.value" @click="handleInputClick" @blur="onColorChangeStatus(rfsts, $event)" />
                        </div>
                      </div>
                    </button>
                    <button class="button is-danger" @click="logicalDeleteRfsts(rfsts)" style="display: block; margin-top: 8px; margin-bottom: 8px; margin-left: 8px; height: 56px; width: 56px; border-radius: 0;">
                      <span class="mdi mdi-delete"></span><br/>
                      <p style="font-size: smaller;">削除</p>
                    </button>
                  </template>
                </div>
              </div>
            </template>
            <template v-if="selectStage&&selectStatus&&!selectAction">
              <div style="display: flex; margin-bottom: 8px;">
                <input class="input is-small" style="width: calc(100% - 126px); border-radius: 0;" placeholder="アクション名" v-model="createNameRecruitmentFlowAction"/>
                <input type="color" style="width: 50px; margin: auto 10px;" v-model="createColorRecruitmentFlowAction"/>
                <button class="button is-small is-primary" style="width: 56px; border-radius: 0;" @click="createRecruitmentFlowAction()" :disabled="!createNameRecruitmentFlowAction">+ 追加</button>
              </div>
              <div class="scrollable disp-scroll" style="height: calc(100% - 110px);">
                <div style="display: flex;" v-for="(rfats, idx) in selectStatus.actions" :key="idx + '-rfats'">
                  <button class="button" style="display: block; text-align: left; margin-top: 8px; margin-bottom: 8px; height: 56px; width: 100%; border: solid 2px #99e; border-radius: 0; padding: 0 12px;" @click="selectAction=rfats">
                    <div style="display: flex;">
                      <div style="display: flex;">
                        <span class="mdi mdi-square" style="margin-right: 2px;" :style="{ color: rfats.color }"/>
                        <p>{{rfats.name}}</p>
                      </div>
                      <div style="display: flex; flex-direction: row; margin: auto 0 auto auto; align-items: center;" >
                        <input type="color" style="width: 40px;" :value="rfats.color ? rfats.color : '#ffffff'" @input="event => rfats.color = event.target.value" @click="handleInputClick" @blur="onColorChangeAction(rfats, $event)" />
                      </div>
                    </div>
                  </button>
                  <button class="button is-danger" @click="confiDeleteAction(rfats.pk)" style="display: block; margin-top: 8px; margin-bottom: 8px; margin-left: 8px; height: 56px; width: 56px; border-radius: 0;">
                    <span class="mdi mdi-delete"></span><br/>
                    <p style="font-size: smaller;">削除</p>
                  </button>
                </div>
              </div>
            </template>
            <template v-if="selectStage&&selectStatus&&selectAction">
              <div style="display: flex; align-items: center; margin-bottom: 16px;">
                <p style="text-align: left; font-size: smaller; width: 150px;">連絡方法</p>
                <select v-model="selectAction.type" class="select is-small" style="width: 100%">
                  <option value="0">Eメール</option>
                  <option value="1">SMS</option>
                  <option value="2">電話</option>
                </select>
              </div>
              <div v-if="selectAction.type == 0" style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
                <p style="margin-right: 4px; font-size: smaller; width: 150px;">FROM:</p>
                <input class="input is-small" v-model="selectAction.from_email"/>
              </div>
              <div v-if="selectAction.type == 1" style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
                <p style="margin-right: 4px; font-size: smaller; width: 150px;">送信元:</p>
                <input class="input is-small" v-model="selectAction.from_sms_name"/>
              </div>
              <div v-if="selectAction.type == 1" style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
                <p style="margin-right: 4px; font-size: smaller; width: 110px;"></p>
                <p style="font-weight: normal; color: gray; font-size: 14px;">※送信元は11文字以内の英数字のみ使用できます。</p>
              </div>
              <div v-if="selectAction.type == 0||selectAction.type == 1" style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
                <p style="margin-right: 4px; font-size: smaller; color: #666; width: 112px;">TO:</p>
                <p style="color: #666; font-size: 14px;">自動で設定されます</p>
              </div>
              <div v-if="selectAction.type == 0" style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
                <p style="margin-right: 4px; font-size: smaller; width: 150px;">CC:</p>
                <input class="input is-small" v-model="selectAction.cc_email"/>
              </div>
              <div v-if="selectAction.type == 0" style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
                <p style="margin-right: 4px; font-size: smaller; width: 150px;">件名:</p>
                <input class="input is-small" v-model="selectAction.email_subject"/>
              </div>
              <div v-if="selectAction.type == 0||selectAction.type == 1" style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
                <p style="width:112px; margin-right: 4px; font-size: smaller;">送付日:</p>
                <input min="0" class="input is-small" style="width: 80px" type="number" v-model="selectAction.delay_days"/>
                <p style="margin-left: 4px; font-size: smaller;">日後</p>
                <p style="margin-left: 16px; font-weight: normal; color: gray; font-size: 14px;">送信時に個別変更も可能です。</p>
              </div>
              <div style="display: flex; align-items: center; margin-bottom: 8px; font-weight: 600;">
                <template v-if="selectAction.delay_days && selectAction.delay_days !== '0'">
                  <p style="width:112px; margin-right: 4px; font-size: smaller;">送付時刻:</p>
                  <input
                    min="0"
                    type="time"
                    step="900"
                    class="input is-small"
                    style="width: 80px"
                    v-model="selectAction.delay_time"
                  />
                  <p style="margin-left: 4px; font-size: smaller;">時</p>
                </template>
                <template v-else>
                  <p style="width:112px; margin-right: 4px; font-size: smaller;">送付時刻:</p>
                  <input
                    min="0"
                    max="23"
                    class="input is-small"
                    style="width: 80px"
                    type="number"
                    v-model="selectAction.hours_later"
                  />
                  <p style="margin-left: 4px; font-size: smaller;">時間後</p>
                </template>
              </div>
              <WYSIWYGAndPlainTextEditer 
                v-if="selectAction.type == 0||selectAction.type == 1"
                style="height: calc(100% - 500px);"
                v-model="selectAction.email_content"
                :isEditingPlainText="selectAction.type == 1"/>
              <button
                class="button is-small is-fullwidth is-primary"
                style="margin-top: 16px;"
                @click="updateRecruitmentFlowAction(selectAction)"
              >
                保存
              </button>
              <div v-if="selectAction.type == 0||selectAction.type == 1" style="display: flex; align-items: center; margin-top: 8px">
                <p style="text-align: left; font-size: smaller; width: 150px">
                  <span class="mdi mdi-robot" style="margin-right: 8px"></span>ロボリンク
                </p>
                <select
                  v-model="selectAction.chatbots"
                  class="select is-small"
                  style="width: calc(100% - 176px); margin-right: 8px"
                >
                  <template v-for="(c, i) in isConfirmChatbot(chatbots)">
                    <option :key="i + '-tempbot'" :value="c.bot_id" v-if="!c.is_archive">
                      {{ c.name }}
                    </option>
                  </template>
                </select>
                <button
                  class="button is-small is-primary"
                  style="border-radius: 4px"
                  @click="
                    helpMessage(
                      '__robo_url__とメール本文に挿入することで自動的に設定されたロボのリンクが作成されます。'
                    )
                  "
                >
                  <span class="mdi mdi-help-circle-outline"></span>
                </button>
              </div>
              <p v-if="selectAction.type == 0||selectAction.type == 1" style="font-weight: normal; color: gray; font-size: 14px;">
                応募者の名前は__name__で反映されます。
              </p>
              <p v-if="selectAction.type == 0" style="font-weight: normal; color: gray; font-size: 14px;">__received_form__とメール内容に入力すると返信用フォームのリンクに変換されます。</p>
            </template>
          </template>
          <!-- 初期設定 -->
          <template v-else>
            <div style="width: 100%; text-align: center;">
              <img style="margin-top: 8px; width: 250px; height: 250px;" src="@/assets/template/create_flow.png"/>
              <p style="margin-top: 8px; font-size: smaller; text-align: left; padding-left: 16px;">
                採用フローの初期設定が完了しておりません。<br/>
                こちらから初期作成を行い、採用業務を自動化しましょう。
              </p>
              <button @click="$store.dispatch('auth/initialCreateRecruitmentFlow')" style="margin-top: 8px;" class="button is-small is-primary is-fullwidth" :disabled="isInitCreatingRecruitmentFlow">
                <template v-if="!isInitCreatingRecruitmentFlow">初期設定を行う</template>
                <template v-else><span class="mdi mdi-loading mdi-spin"></span></template>
              </button>
            </div>
          </template>
        </div>
      </div>
    </transition>
    <!-- 採用フロー自動化設定 -->
    <transition name="right">
      <SettingAutoFlowMenu
        v-if="isAutoOpenFlowMenu"
        :toggleAutoFlowModal="toggleAutoFlowModal"
        :createAutoFlow="createAutoFlow"
        :deleteAutoFlow="deleteAutoFlow"
        :recruitList="sortedFilteredRecruitList"
        :recruitFlowActionObj="recruitFlowActionObj"
        :selectAutoFlowAction="selectAutoFlowAction"
        :actionTiming="actionTiming"
        :autoFlowList="autoFlowList"
        :companyRecruit="companyRecruit"
        :chatbots="chatbots"
        :PCTRLLOG="CTRLLOG"
      />
    </transition>
    <!-- 採用フロー停止設定 -->
    <transition name="right">
      <SettingPauseAutoFlow
        v-if="isPauseAutoFlowSetting"
        :createPauseAutoFlowSetting="createPauseAutoFlowSetting"
        :deletePauseAutoFlowSetting="deletePauseAutoFlowSetting"
        :pauseDaysWeek="pauseDaysWeek"
        :pauseAutoFlowSettingList="pauseAutoFlowSettingList"
        :PCTRLLOG="CTRLLOG"
      />
    </transition>
    <!-- 採用フロー停止応募者設定 -->
    <transition name="right">
      <SettingApplicantBlacklist
        v-if="isApplicantBlacklist"
        :PCTRLLOG="CTRLLOG"
        @blacklist-added="handleBlacklistChange"
        @blacklist-deleted="handleBlacklistDeleted"
      />
    </transition>
    <!-- 応募者インポート -->
    <ModalImportSeeker
      :isShowModal="isShowModalImportSeeker"
      :companyColumnSetting="companyColumnSetting"
      :isLoading="isImportLoading"
      :select_manages="select_manages"
      :user="user"
      :isResponseWaiting="isResponseWaiting"
      :loadingTitle="loadingTitle"
      :loadingMessage="loadingMessage"
      @cancel="changeModalImportSeeker"
      @import-seeker="importSeeker"
      v-if="isShowModalImportSeeker"
      :PCTRLLOG="CTRLLOG"
    />
    <!-- 応募者管理画面 -->
    <ManageView
      ref="manageView"
      :currentManage="currentManage"
      :blacklistTab="blacklistTab"
      :bulkSeekerList="bulkSeekerList"
      :recruitList="sortedRecruitList"
      :dataForMailAction="dataForMailAction"
      :isSeekerLoading="isSeekerLoading"
      :notAllowSeekerInfo="notAllowSeekerInfo"
      :changeCurrentManage="changeCurrentManage"
      :changeBlacklistTab="changeBlacklistTab"
      @sendMessage="sendMessage"
      @selectRoom="selectRoom"
      @sendEmail="sendEmail"
      @BulkManage = "BulkManage"
      @sendSMS="sendSMS"
      @checkbox="checkbox"
      @checkbox-all="checkboxAll"
      @open-create-manage-menu ="openCreateManageMenu"
      @open-flow-menu="openFlowMenu"
      @open-auto-flow-menu="openAutoFlowMenu"
      @open-pause-auto-flow-setting="openPauseAutoFlowSetting"
      @open-applicant-blacklist="openApplicantBlacklist"
      @open-cloud-sync="openCloudSync"
      @open-table-setting="openTableSetting"
      @open-email-template="openEmailTemplate"
      @open-modal-import-seeker="changeModalImportSeeker"
      @open-export-modal="openExportModal"
      @open-detail-sheet-setting="openDetailSheetSetting"
      :PCTRLLOG="CTRLLOG"
    />
    <BasicModal
      title="アクションの設定"
      :isShowModal="isAutoOpenFlowModal"
      width="320px"
      @cancel="toggleAutoFlowModal(false)"
    >
      <!-- ステージ -->
      <div style="padding: 16px;">
        <div>
          <div>
            <p>ステージ</p>
          </div>
          <template v-if="recruitmentFlows.length > 0">
            <select 
              class="select" 
              v-model="selectAutoFlowStage" 
              @change="resetStatusAndAction"
            >
              <option
                v-for="(sortByStage, i) in filteredSortByStages"
                :value="sortByStage.pk"
                :key="`stage-${i}`"
              >
                {{ sortByStage.name }}
              </option>
            </select>
          </template>
        </div>
        <!-- ステータス -->
        <div style="margin-top: 16px">
          <div>
            <p>ステータス</p>
          </div>
          <template v-if="recruitmentFlows.length > 0">
            <select
              class="select"
              v-model="selectAutoFlowStatus"
              :disabled="!getRecruitmentFlowStatus(selectAutoFlowStage)"
            >
              <option
                v-for="(sts, i) in getRecruitmentFlowStatus(selectAutoFlowStage)"
                :value="sts.pk"
                :key="`status-${i}`"
              >
                {{ sts.name }}
              </option>
            </select>
          </template>
        </div>
        <!-- アクション -->
        <div style="margin-top: 16px">
          <div>
            <p>アクション</p>
          </div>
          <template v-if="recruitmentFlows.length > 0">
            <template>
              <select
                class="select"
                v-model="selectAutoFlowAction"
                :disabled="!getRecruitmentFlowActions(selectAutoFlowStatus)"
              >
                <option
                  v-for="(sts, i) in getRecruitmentFlowActions(selectAutoFlowStatus)"
                  :value="sts.pk"
                  :key="`status-${i}`"
                >
                  {{ sts.name }}
                </option>
              </select>
            </template>
          </template>
        </div>
        <!-- ボタン -->
        <div style="margin-top: 24px">
          <div style="display: flex; justify-content: space-between;">
            <button class="button" style="width: 50%;" @click="closeAutoOpenFlowModal">
              キャンセル
            </button>
            <button
              @click="clickAutoActionReflectButton()"
              class="button is-primary" style="width: 50%; margin-left: 8px;"
              :disabled="!selectAutoFlowAction"
            >
              反映する
            </button>
          </div>
        </div>
      </div>
    </BasicModal>
    <BasicModal
      :isShowModal="isExportModal"
      title="エクスポート"
      width="480px"
      :canCancel="true"
      @cancel="toggleExportModal(false)"
    >
      <ExportModalContent
        :executeCsvExport="executeCsvExport"
        :thisMonth="thisMonth"
        :isMakingCSV="isMakingCSV"
      />
    </BasicModal>
    <SendHistory
      :isShowModal="isOpenSendHistory"
      :canCancel = true
      :isSeekerLoading="isSeekerLoading"
      :bulkSeekerList="bulkSeekerList"
      :notAllowSeekerInfo="notAllowSeekerInfo"
      @sendEmail="sendEmail"
      @checkbox="checkbox"
      @checkbox-all="checkboxAll"
      @cancel="cancelSendHistory"
    />    
    <!-- 媒体連携項目設定 -->
    <MediaCooperationItemMasterSetting
      ref="media_cooperation_item_master_setting"
      :roboList="chatbots"
      :companyColumnSetting="companyColumnSetting"
      :PCTRLLOG="CTRLLOG"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import draggable         from 'vuedraggable'
import Balloon           from '@/components/ui/Balloon'
import InputForm         from '@/views/DashBoard/DirectTalk/InputForm'
import ManageView        from '@/views/DashBoard/Manage/ManageView'
import ModalImportSeeker from '@/views/DashBoard/Manage/ModalImportSeeker'
import TableSetting      from '@/components/Manage/TableSetting'
import SelectionOptionsModal     from '@/components/Manage/SelectionOptionsModal'
import EmailTemplate     from '@/components/Manage/EmailTemplate'
import MailAction        from '@/components/Manage/MailAction'
import SMSAction         from '@/components/Manage/SMSAction'
import BasicModal from '@/components/Modals/BasicModal'
import SettingAutoFlowMenu from '@/components/organisms/slidemenus/SettingAutoFlowMenu'
import SettingPauseAutoFlow from '@/components/organisms/slidemenus/SettingPauseAutoFlow'
import SettingApplicantBlacklist from '@/components/organisms/slidemenus/SettingApplicantBlacklist'
import ExportModalContent from '@/components/organisms/contents/ExportModalContent'
import SendHistory from '@/components/organisms/contents/SendHistory'
import DetailSheetSetting from '@/components2/Manage/modal/DetailSheetSetting'
import WYSIWYGAndPlainTextEditer from '@/components/ui/WYSIWYGAndPlainTextEditer'
import controlLogMixin from '@/mixins/controlLogMixin'
// 媒体連携項目設定モーダル
import MediaCooperationItemMasterSetting from '@/hrm-frontend/views/atomic/screen-components/applicant-components/atomic-templates/media-cooperation/MediaCooperationItemMasterSetting'
import {
  isMailAddress,
  isSMSAddress,
  isDataNull,
  } from '@/functions/common/checksFunc'

export default {
  components: {
    draggable,
    Balloon,
    InputForm,
    ManageView,
    ModalImportSeeker,
    TableSetting,
    SelectionOptionsModal,
    EmailTemplate,
    MailAction,
    SMSAction,
    BasicModal,
    SettingAutoFlowMenu,
    SettingPauseAutoFlow,
    SettingApplicantBlacklist,
    ExportModalContent,
    SendHistory,    
    DetailSheetSetting,
    WYSIWYGAndPlainTextEditer,
    MediaCooperationItemMasterSetting,
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      COMPONENT_NAME: 'ManageMainView',
      isOpenCloudSync: false,
      isOpenTableSettingMenu: false,
      isSelectionOptionsModalOpen: false,
      isOpenTemplateMenu: false,
      isOpenMessageMenu: false,
      isOpenEmailMenu: false,
      isOpenUpdateManageMenu: false,
      isOpenCreateManageMenu: false,
      isOpenSMSMenu: false,
      isOpenFlowMenu: false,
      isAutoOpenFlowMenu: false,
      isPauseAutoFlowSetting: false,
      isApplicantBlacklist: false,
      isShowModalImportSeeker: false,
      isOpenDetailSheetSetting: false,
      isImportLoading: false,
      isSeekerLoading: false,
      isEmailEditing: false,  // メール編集中かどうかを追跡する変数を追加
      isSMSEditing: false,    // SMS編集中かどうかを追跡する変数を追加
      sendEmailTemplate: null,
      sendSMSTemplate: null,
      selectStage: null,
      selectStatus: null,
      selectAction: null,
      selectedColumnId: null, // 選択式カラムの選択肢追加（id）
      selectedColumnName: '',  // 選択式カラムの選択肢追加（名称）
      createNameRecruitmentFlowStage: null,
      createNameRecruitmentFlowStatus: null,
      createNameRecruitmentFlowAction: null,
      createColorRecruitmentFlowStage: '#ffffff',
      createColorRecruitmentFlowStatus: '#ffffff',
      createColorRecruitmentFlowAction: '#ffffff',
      createNameManage: null,
      templateIndex: 0,
      addTemplates: null,
      options: {
        theme: 'snow',
        placeholder: '内容を入力...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }]]
        }
      },
      uri: location.href,
      isTyping: '',
      action: [],
      isNoScroll: false,
      singleURL: '',
      updateManage: [],
      currentManage: null,
      blacklistTab: false,
      set_archiveflg: false,
      set_blacklistflg: false,
      set_perpage: 30,
      set_seekerspage: 1,
      set_filtered: [],
      set_filter_type: false,
      tempChatBot: null,
      tempCompanyColumnSetting: [],
      tempCompanyRecruit: {
        type: 0,
        rec_account_id: '',
        rec_id: '',
        rec_password: '',
        url: '',
        cp_name: '',
        update_frequency: 60,
        manage_id: [],
      },
      nullChatBot: {
        bot_id: null,
        name: null,
        is_archive: false
      },
      nullStory: {
        pk: null,
        title: null,
        is_archive: false
      },
      actionTypes: [
        'なし',
        '応募',
        '日程調整',
        '面接後設定',
        '選考結果'
      ],
      bulk: false,
      bulkSeekerList: [],
      sendLoadding: false,
      recruitList: [],
      actionTiming: [
        '応募者管理画面反映時',
        '面接終了時',
        'ゴール通過時'
      ],
      now: new Date(),
      selectAutoFlowStage: null,
      selectAutoFlowStatus: null,
      selectAutoFlowAction: null,
      isAutoOpenFlowModal: false,
      autoActionSelected: "",
      recruitFlowActionObj: null,
      pauseDaysWeek: [
        '月曜日',
        '火曜日',
        '水曜日',
        '木曜日',
        '金曜日',
        '土曜日',
        '日曜日',
        '祝日'
      ],
      autoFlowList: [],
      pauseAutoFlowSettingList: [],
      isExportModal: false,
      isOpenSendHistory: false,      
      exportMonthFrom: '',
      exportMonthTo: '',
      isResponseWaiting: false,
      loadingTitle: '処理中です...',
      loadingMessage: '',
      asyncJobId: null,
      asyncJobStatus: null,
      asyncJobPollingInterval: null,
    }
  },
  created () {
    this.$store.dispatch('auth/getMediaCooperationList')
    this.$store.dispatch('auth/getRecruitmentFlow')
    const authUser = this.users.filter(i=>i.email === this.user.email)
    this.$store.dispatch('auth/getCompanyRecruit', null)
    if(this.manages.lengh === 0){
      this.$store.dispatch('auth/getcreateManage')
    }
    this.currentManage = this.default_manage.pk
    this.blacklistTab = false
    const getSeekerConditions = {
      is_archive: false,
      is_blacklist: false,
      filter_type: false,
      filter: [],
      page: 1,
      perPage: 30,
      manageid: this.default_manage.pk,
      // 2024/01/06
      // 初回表示で応募者重複フラグONをデフォルトにする
      // フラグON/OFFは現在非表示なので、表示要望があった時にデフォルトをONにするかOFFにするか検討する
      // 応募者重複フラグ設定をDBに格納する場合は、その値を初期値にする (Userモデルにフィールド追加を想定)
      is_duplicate_seeker_flag: true,
      // ロボ会話履歴取得フラグ (応募者一覧を取得する場合はデフォルトtrue)
      is_get_robo_talk: true
    }
    this.$store.dispatch('directtalk/getSubscribedSeekers', {conditions: getSeekerConditions, authUser: authUser, isAgent: this.user.isAgent})
    this.$store.dispatch('auth/getCompanyEmailTemplate', null)
    this.$store.dispatch('auth/getCompanySMSTemplate', null)
    if (this.user.companySMSTEL !== '') {
      this.$store.dispatch('directtalk/getCompanySMSHistory', {tel:this.user.companySMSTEL})
    }
    this.$store.dispatch('auth/getCompanyColumnSetting', null)
    this.$store.dispatch('directtalk/getRecordingInterview', null)
    this.getAutoFlow()
    this.getPauseFlow()
  },
  mounted () {
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)
  },
  filters: {
    isDeleteApplyCount(value) {
      let count = 0
      value.forEach((items) => {
        if (items.is_delete_apply == false) {
          count++
        }
      });
      return count;
    }
  },
  computed: {
    ...mapState('auth', ['user', 'users', 'calendarEventHistory', 'emailTemplates', 'SMSTemplates', 'companyColumnSetting', 'companyRecruit', 'recruitmentFlows', 'isInitCreatingRecruitmentFlow', 'calendarSettings', 'calendarBookMarks','manages','select_manages','default_manage','displaycompanyRecruit', 'mediaCooperationList']),
    ...mapState('chatbot', ['chatbots', 'stories']),
    ...mapState('directtalk', ['seekers', 'filteredSeekers', 'isMakingCSV', 'chatData', 'roomlist', 'chatLogs', 'typing', 'selectroom', 'seeker', 'chatLogsLoading', 'messagePages', 'isVideo', 'scrolltalk', 'getSeekerType', 'isConnectRoom', 'isGetMessageMax', 'recordingInterviews','detailManage']),
    ...mapState('calendar', ['events', 'schedules', 'isScheduleLoading', 'userData', 'eventFileGroup', 'eventGroup']),
    ...mapState("setting",["isMenuMiniSize"]),
    ...mapState("recruitmentMedia", ["modalState"]),
    ...mapGetters('auth', ['getPulldownOptionsForColumn']),
    isOpenRightMenu () {
      return this.isOpenCloudSync || this.isOpenTableSettingMenu || this.isOpenTemplateMenu || this.isOpenEmailMenu || this.isOpenSMSMenu || this.isOpenFlowMenu || this.isOpenMessageMenu || this.isAutoOpenFlowMenu || this.isPauseAutoFlowSetting || this.isApplicantBlacklist || this.isOpenCreateManageMenu || this.isOpenUpdateManageMenu || this.isOpenDetailSheetSetting || this.isSelectionOptionsModalOpen
    },
    sortByStages () {
      return this.recruitmentFlows[0].stages
        .slice().sort((a, b) => {
            if(a.order < b.order) return -1;
            if(a.order > b.order) return 1;
            return 0;
        });
    },
    filteredSortByStages(){
      const filterSortByStage = this.sortByStages.filter(x => x.is_delete_apply === false);
      return filterSortByStage
    },
    thisMonth() {
      const date = new Date()
      const year = new Date().getFullYear()
      const tmpMonth = String(date.getMonth() + 1)
      const month = String(date.getMonth() + 1).length === 1 ? `0${tmpMonth}` : tmpMonth
      return `${year}-${month}`
    },
    sortedRecruitList() {
      return this.recruitList.slice().sort((x, y) => {return (x.name < y.name ? -1 : 1)})
    },
    sortedFilteredRecruitList() {
      // プラスアイ(template_type=49)は媒体連携設定からは外す
      const removeArray = [49]
      const filteredRecruitList = this.recruitList.filter(function(v){
        return ! removeArray.includes(v.type)
      })
      return filteredRecruitList.slice().sort((x, y) => {return (x.name < y.name ? -1 : 1)})
    },
    dataForMailAction() {
      // MailActionContentに必要なデータをひとまとめで渡したい
      return {
        chatbots: this.chatbots,
        recordingInterviews: this.recordingInterviews,
        users: this.users,
        options: this.options,
        sendLoadding: this.sendLoadding,
        emailTemplates: this.emailTemplates,
        sendEmailTemplate: this.sendEmailTemplate,
        changeEmailTemplate: this.changeEmailTemplate,
        sendEmailToSeeker: this.sendEmailToSeeker,
        copyLink: this.copyLink,
      }
    },
    notAllowSeekerInfo() {
      if(this.user.isSeekerDisplayEnable) {
        return false
      } else {
        return true
      }
    },
    setGradiationYear() {
      let yearlist = []
      let calyear
      let nowyear = new Date().getFullYear()
      calyear = nowyear - 1
      for (let i = 0; i < 5; i++) {
        yearlist.push(String(calyear + i))
      }
      return yearlist
    },
    isUserAdmin() {
      return this.user.permission === 0;
    },    
  },
  watch : {
    // 応募者管理画面のロボ会話履歴はチャット機能がなく再接続の必要がないので削除
    // isConnectRoom: function () {
    //   if (!this.isConnectRoom) {
    //     var uri = process.env.WS_ENDPOINT + this.user.companyID + '/' + this.selectroom.name + '/'
    //     this.$store.dispatch('directtalk/connect', {uri: uri, category: 'managementtool'})
    //   }
    // },
    chatLogs: function () {
      if (this.chatLogs.length !== 0) {
        this.$nextTick()
        setTimeout(() => {this.scrollDown()}, 0)
        this.$store.dispatch('directtalk/setIsRead', 'mgtool')
      }
    },
    mediaCooperationList () {
      this.recruitList = this.mediaCooperationList
    },
    // テーブル設定メニューの状態を監視
    isOpenTableSettingMenu: {
      async handler() {
        if (!this.isOpenTableSettingMenu) {
          try {
            this.sendControlLog('テーブル設定変更', 'テーブル設定にて、設定を行った。')
            // カスタムカラムの設定を取得
            await this.updateCompanyColumnSetting();

            if (this.companyColumnSetting && Array.isArray(this.companyColumnSetting)) {
              const pulldownColumns = this.companyColumnSetting.filter(col =>
                col.is_pulldown_flg === 1 || col.is_pulldown_flg === '1' || col.is_pulldown_flg === true
              );

              for (const col of pulldownColumns) {
                if (col.pk !== undefined) {
                  await this.fetchCompanyPulldownColumns({ columnId: col.pk });
                }
              }
            }

          } catch (error) {
            console.error('マウント処理中にエラーが発生しました:', error);
            this.openAlert('データの読み込み中にエラーが発生しました');
          }
        }
      },
      immediate: true
    }
  },
  methods: {
  /**
   * モーダル表示
   * @param {*} modalName モーダル名
   * @returns なし
   */
    ...mapActions('auth', ['fetchCompanyPulldownColumns', 'getCompanyColumnSetting', 'updateCompanyPulldownOptions']),
    openModal (modalName) {
      this.$store.dispatch('recruitmentMedia/openModal', modalName)
    },
    confiDeleteAction(pk){
      if (!confirm('このアクションを削除してよろしいですか？')) {
        return
      }
      this.sendControlLog('採用フロー設定 アクション削除', '採用フロー設定にて、アクションを削除した。')
      this.$store.dispatch('auth/deleteRecruitmentFlowAction', pk)
    },
    async getAutoFlow () {
      try {
        const response = await this.$store.dispatch('directtalk/getAutoFlow')
        let flowBuffer = []
        if (this.user.isAgent && process.env.WS_ENDPOINT.indexOf('localhost') >= 0) {
          // ローカルでスーパーユーザーの時だけ、そのまま格納する
          flowBuffer = response.data
        } else {
          // テスト用ダミー媒体を除外する
          for (let flow of response.data) {
            if (flow.type !== 50) {
              flowBuffer.push(flow)
            }
          }
        }
        this.autoFlowList = flowBuffer.reverse()
      } catch (e) {
        console.log(e)
        // alert("エラーが発生しました。")
      }
    },
    async createAutoFlow (data) {
      try {
        const response = await this.$store.dispatch('directtalk/createAutoFlow', data)
        this.autoFlowList.unshift(response.data)
        alert("登録しました。")
      } catch (e) {
        console.log(e)
        alert("エラーが発生しました。")
      }
    },
    async getPauseFlow () {
      try {
        const response = await this.$store.dispatch('directtalk/getPauseFlow')
        let settingBuffer = response.data
        this.pauseAutoFlowSettingList = settingBuffer.reverse()
      } catch (e) {
        console.log(e)
        // alert("エラーが発生しました。")
      }
    },
    async createPauseAutoFlowSetting (
      daysWeekSelected,
      pauseAutoFLowStartTimeInput,
      pauseAutoFLowEndTimeInput
    ) {
      const data = {
        day_week: daysWeekSelected,
        start_time: pauseAutoFLowStartTimeInput,
        end_time: pauseAutoFLowEndTimeInput
      }
      try {
        const response = await this.$store.dispatch('directtalk/createPauseFlow', data)
        this.pauseAutoFlowSettingList.unshift(response.data)
        alert("登録しました。")
      } catch (e) {
        console.log(e)
        alert("エラーが発生しました。")
      }
    },
    async deleteAutoFlow (id) {
      if (!confirm('この自動採用フローを削除してよろしいですか？')) {
        this.sendControlLog('自動採用フロー削除をキャンセル', '採用フロー自動化設定にて、削除ボタンをクリックした後の確認にて、削除をキャンセルした。')
        return
      }
      try {
        await this.$store.dispatch('directtalk/deleteAutoFlow', id)
        this.autoFlowList = this.autoFlowList.filter(el => el.id !== id)
        alert("削除しました。")
      } catch (e) {
        console.log(e)
        alert("エラーが発生しました。")
      }
    },
    async deletePauseAutoFlowSetting (id) {
      if (!confirm('この自動採用フロー停止設定を削除してよろしいですか？')) {
        this.sendControlLog('採用フロー停止設定の削除をキャンセル', '採用フロー停止設定にて、削除ボタンをクリックした後の確認にて、削除をキャンセルした。')
        return
      }
      try {
        await this.$store.dispatch('directtalk/deletePauseFlow', id)
        this.pauseAutoFlowSettingList = this.pauseAutoFlowSettingList.filter(el => el.id !== id)
        alert("削除しました。")
      } catch (e) {
        console.log(e)
        alert("エラーが発生しました。")
      }
    },
    clickAutoActionReflectButton () {
      this.setAutoActionSelected()
      this.getRecruitmentFlowActionName(this.selectAutoFlowAction)
      this.closeAutoOpenFlowModal()
    },
    setAutoActionSelected () {
      this.autoActionSelected = this.selectAutoFlowAction
    },
    closeAutoOpenFlowModal () {
      this.isAutoOpenFlowModal = false
    },
    resetStatusAndAction () {
      this.selectAutoFlowStatus = null
      this.selectAutoFlowAction = null
    },
    getRecruitmentFlowStatus (stg) {
      let RecruitmentFlowStatus = []
      if (!stg || this.recruitmentFlows.length === 0) return null
      for (let stage of this.recruitmentFlows[0].stages) {
        if (stage.pk === stg) {
          for (let status of stage.status){
            if(status.is_delete_apply === false){
              RecruitmentFlowStatus.push(status)           
            }
          }
        }
      }
      return RecruitmentFlowStatus
    },
    getRecruitmentFlowActions (sts) {
      if (!sts || this.recruitmentFlows.length === 0) return null
      for (let i in this.recruitmentFlows[0].stages) {
        for (let re of this.recruitmentFlows[0].stages[i].status) {
          if (re.pk === sts) return re.actions
        }
      }
      return null
    },
    getRecruitmentFlowActionName (pk) {
      if (!pk || this.recruitmentFlows.length === 0) return null
      for (let i in this.recruitmentFlows[0].stages) {
        for (let re of this.recruitmentFlows[0].stages[i].status) {
          if (re.pk === this.selectAutoFlowStatus) {
            const actionArr = re.actions.filter(el => el.pk === pk)
            this.recruitFlowActionObj = actionArr[0]
          }
        }
      }
      return null
    },
    toggleAutoFlowModal (flg) {
      this.isAutoOpenFlowModal = flg
    },
    logicalDeleteRfstg(rfstg){
      if (!confirm('この採用ステージを削除してよろしいですか？')) {
        return
      }
      rfstg.status.forEach((sts) => {
        if (sts.is_delete_apply == false) {
          sts.actions.forEach((actions) => {
            this.$store.dispatch('auth/deleteRecruitmentFlowAction', actions.pk)
          });
          sts.is_delete_apply = true
          this.$store.dispatch('auth/updateRecruitmentFlowStatus', sts)
        }
      });
      this.sendControlLog('採用フロー設定 ステージ削除', '採用フロー設定にて、ステージを削除した。')
      rfstg.is_delete_apply = true
      this.$store.dispatch('auth/updateRecruitmentFlowStage', rfstg)
    },
    logicalDeleteRfsts(rfsts){
      if (!confirm('この採用ステータスを削除してよろしいですか？')) {
        return
      }
      rfsts.actions.forEach((actions) => {
        this.$store.dispatch('auth/deleteRecruitmentFlowAction', actions.pk)
      })
      this.sendControlLog('採用フロー設定 ステータス削除', '採用フロー設定にて、ステータスを削除した。')
      rfsts.is_delete_apply = true
      this.$store.dispatch('auth/updateRecruitmentFlowStatus', rfsts)
    },
    // 編集状態を設定するメソッド
    setEmailEditing (isEditing) {
      this.isEmailEditing = isEditing
    },
    setSMSEditing (isEditing) {
      this.isSMSEditing = isEditing
    },
    closeRightMenu () {
      // メールまたはSMSの編集中かどうかをチェック
      if (this.isEmailEditing && this.isOpenEmailMenu) {
        // 確認ダイアログを表示
        this.$buefy.dialog.confirm({
          title: '確認',
          message: '編集中の場合には、文章が消えてしまいますが、よろしいでしょうか？（必要な場合には、一時保存ボタンを押してください）',
          confirmText: 'はい',
          cancelText: 'いいえ',
          type: 'is-primary',
          onConfirm: () => {
            // 確認された場合、メニューを閉じる
            this.closeAllRightMenus()
          }
        })
        return
      } else if (this.isSMSEditing && this.isOpenSMSMenu) {
        // 確認ダイアログを表示
        this.$buefy.dialog.confirm({
          title: '確認',
          message: '編集中の場合には、文章が消えてしまいますが、よろしいでしょうか？（必要な場合には、一時保存ボタンを押してください）',
          confirmText: 'はい',
          cancelText: 'いいえ',
          type: 'is-primary',
          onConfirm: () => {
            // 確認された場合、メニューを閉じる
            this.closeAllRightMenus()
          }
        })
        return
      }
      
      // 編集中でない場合は直接メニューを閉じる
      this.closeAllRightMenus()
    },
    // すべての右メニューを閉じるメソッド（重複を避けるため抽出）
    closeAllRightMenus() {
      this.isOpenCloudSync = false
      this.isOpenTableSettingMenu = false
      this.isSelectionOptionsModalOpen = false
      this.isOpenTemplateMenu = false
      this.isOpenEmailMenu = false
      this.isOpenUpdateManageMenu = false
      this.isOpenCreateManageMenu = false
      this.isOpenSMSMenu = false
      this.isOpenFlowMenu = false
      this.isOpenMessageMenu = false
      this.isAutoOpenFlowMenu = false
      this.isPauseAutoFlowSetting = false
      this.isApplicantBlacklist = false
      this.isOpenDetailSheetSetting = false
    },
    saveColumnOrderTableSetting (temp) {
      for (let i in temp) {
        let tempOrder = temp[i]
        tempOrder.order_type = Number(i)
        tempOrder.is_sticky = false
        this.tempCompanyColumnSetting.splice(i, 1, tempOrder)
      }
      this.updateCompanyColumnSetting()
    },
    saveColumnOrderEmailTemplate (serv, temp) {
      for (let i in temp) {
        let tempOrder = temp[i]
        tempOrder.order_type = Number(i)
        serv == 'Email' ? this.emailTemplates.splice(i, 1, tempOrder) : this.SMSTemplates.splice(i, 1, tempOrder)
      }
      let data = serv == 'Email' ?  {temp: this.emailTemplates, service: serv} : {temp: this.SMSTemplates, service: serv}
      this.$store.dispatch('auth/updateOrderCompanyEmailTemplate', data)
    },
    createCompanyColumnSetting (data) {
      if (!data.columns || !data.columns.length) {
        alert('一文字以上入力してください')
        return
      }
      let createTemplate = {
        name          : data.columns,  // ここを修正
        template_type : 0,
        order_type    : this.tempCompanyColumnSetting.length,
        is_delete     : false,
        is_disabled   : false,
        select        : '',
        company       : this.user.companyPK,
        is_pulldown_flg: data.isPulldown,
        type_for_custom_column: data.type_for_custom_column // 追加
      }
      this.$store.dispatch('auth/createCompanyColumnSetting', createTemplate)
      alert('新しいカラムを作成をしました。')
    },
    updateCompanyColumnSetting () {
      this.$store.dispatch('auth/updateCompanyColumnSetting', this.tempCompanyColumnSetting)
    },
    deleteCompanyColumnSetting (pk) {
      this.$store.dispatch('auth/deleteCompanyColumnSetting', pk)
    },
    createCompanyEmailTemplate (data) {
      let createTemplate = {
        name       : data == undefined ? 'no title' : data,
        from_email : '',
        to_email   : '',
        cc_email   : '',
        order_type : this.emailTemplates.length == 0 ? 0 : Math.max(...this.emailTemplates.map((t) => t.order_type)) + 1,
        title      : '',
        template   : '',
        company    : this.user.companyPK
      }
      this.$store.dispatch('auth/createCompanyEmailTemplate', createTemplate)
      alert('新規作成をしました。メールテンプレートメニューからお選びください。')
    },
    updateCompanyEmailTemplate (data) {
      let updateTemplate = data
      this.$store.dispatch('auth/updateCompanyEmailTemplate', updateTemplate)
      alert('保存しました。')
    },
    deleteCompanyEmailTemplate (temp) {
      this.$store.dispatch('auth/deleteCompanyEmailTemplate', temp.pk)
      .then(()=> {
        let li = []
        for (let t of this.emailTemplates) {
          if (temp.order_type < t.order_type) {
            let new_list = t
            new_list.order_type = Number(t.order_type) - 1
            li.push(new_list)
          } else if (temp.order_type > t.order_type) {
            li.push(t)
          }
        }
        let data = {temp: li, service: 'Email'} 
        this.$store.dispatch('auth/updateOrderCompanyEmailTemplate', data)
       })
      alert('削除しました。')
    },
    createCompanySMSTemplate (data) {
      let createTemplate = {
        name       : data == undefined ? 'no title' : data,
        to_email   : '',
        order_type : this.SMSTemplates.length == 0 ? 0 : Math.max(...this.SMSTemplates.map((t) => t.order_type)) + 1,
        template   : this.user.companyName + 'です。',
        company    : this.user.companyPK,
        is_SMS      : true
      }
      this.$store.dispatch('auth/createCompanySMSTemplate', createTemplate)
      alert('新規作成をしました。SMSテンプレートメニューからお選びください。')
    },
    updateCompanySMSTemplate (data) {
      let updateTemplate = data
      this.$store.dispatch('auth/updateCompanySMSTemplate', updateTemplate)
      alert('保存しました。')
    },
    deleteCompanySMSTemplate (temp) {
      this.$store.dispatch('auth/deleteCompanySMSTemplate', temp.pk)
      .then(()=> {
        let li = []
        for (let t of this.SMSTemplates) {
          if (temp.order_type < t.order_type) {
            let new_list = t
            new_list.order_type = Number(t.order_type) - 1
            li.push(new_list)
          } else if (temp.order_type > t.order_type) {
            li.push(t)
          }
        }
        let data = {temp: li, service: 'SMS'} 
        this.$store.dispatch('auth/updateOrderCompanyEmailTemplate', data)
       })
      alert('削除しました。')
    },
    // Call Stage Vuex
    createRecruitmentFlowStage () {
      this.sendControlLog('採用フロー設定 ステージ新規作成', '採用フロー設定にて、ステージを新規に作成した。')
      let createRecruitmentFlowStageTemp = {
        name             : this.createNameRecruitmentFlowStage,
        color            : this.createColorRecruitmentFlowStage,
        order            : Number(this.recruitmentFlows[0].stages.length + 1),
        recruitment_flow : this.recruitmentFlows[0].pk,
      }
      this.$store.dispatch('auth/createRecruitmentFlowStage', createRecruitmentFlowStageTemp)
      alert('新規作成をしました。')
      this.createNameRecruitmentFlowStage = null
      this.createColorRecruitmentFlowStage = '#ffffff'
    },
    createManage () {
      if(this.select_manages.length >= 5){
        alert('応募者管理画面は5つ以上作成することはできません。')
        return
      }
      const result = this.manages.filter(m => m.name === this.createNameManage)
      if (result.length > 0) {
        alert('既存の応募者管理画面と同じ名前は使用できません。')
        return
      }
      let createManageTemp = {
        name : this.createNameManage,
        group : this.user.companyPK,
      }
      this.$store.dispatch('auth/createManage', createManageTemp)
      this.sendControlLog('応募者管理画面 追加', '応募者管理画面にて、応募者管理画面の追加を実施した。')
      this.createNameManage = null
    },
    async bulkManageSave() {
      this.isSeekerLoading = true
      this.sendControlLog('応募者管理画面 一括変更', '応募者管理画面にて、応募者の一括振り分けを実施した。')
      this.$emit('cancel', null, false)
      await this.$store.dispatch('directtalk/bulkUpdateSeekerManage', {selectManage: this.updateManage, selectUser: this.bulkSeekerList, group: this.user.companyPK})
      .then(() => {
        alert('応募者の一括振り分けを実施しました。')
      })
      .catch((e) => {
        alert('エラーが発生しました')
      })
      this.updateManage = null
      this.bulkSeekerList = []
      this.isSeekerLoading = false
      await this.$refs.manageView.pageUpdate()
    },
    updateupdateRecruitmentFlowStageRoopDate (stages) {
      for (const i in stages) {
        stages[i].order = i
        this.updateRecruitmentFlowStage(stages[i])
      }
    },
    updateRecruitmentFlowStage (data) {
      let updateRecruitmentFlowStageTemp = data
      this.$store.dispatch('auth/updateRecruitmentFlowStage', updateRecruitmentFlowStageTemp)
    },
    // Call Status Vuex
    createRecruitmentFlowStatus () {
      this.sendControlLog('採用フロー設定 ステータス新規作成', '採用フロー設定にて、ステータスを新規に作成した。')
      let createRecruitmentFlowStatusTemp = {
        name             : this.createNameRecruitmentFlowStatus,
        color            : this.createColorRecruitmentFlowStatus,
        order            : Number(this.selectStage.status.length + 1),
        recruitment_flow_stage : this.selectStage.pk,
      }
      this.$store.dispatch('auth/createRecruitmentFlowStatus', createRecruitmentFlowStatusTemp)
      alert('新規作成をしました。')
      this.createNameRecruitmentFlowStatus = null
      this.createColorRecruitmentFlowStatus = '#ffffff'
    },
    updateRecruitmentFlowStatus (data) {
      let updateRecruitmentFlowStatusTemp = data
      this.$store.dispatch('auth/updateRecruitmentFlowStatus', updateRecruitmentFlowStatusTemp)
      alert('保存しました。')
    },
    // Call Action Vuex
    createRecruitmentFlowAction () {
      this.sendControlLog('採用フロー設定 アクション新規作成', '採用フロー設定にて、アクションを新規に作成した。')
      let createRecruitmentFlowActionTemp = {
        name                   : this.createNameRecruitmentFlowAction,
        color                  : this.createColorRecruitmentFlowAction,
        type                   : Number(this.selectStatus.actions.length + 1),
        recruitment_flow_status: this.selectStatus.pk,
        email_content          : '',
        from_email             : null,
        cc_email               : null,
        delay_days             : 0,
      }
      this.$store.dispatch('auth/createRecruitmentFlowAction', createRecruitmentFlowActionTemp)
      alert('新規作成をしました。')
      this.createNameRecruitmentFlowAction = null
      this.createColorRecruitmentFlowAction = '#ffffff'
    },
    isValidationUpdateRecruitmentFlowAction(selectAction) {
      if (selectAction.type == 0) {
        // Email-FromAddress 未入力チェック
        const strReturn1 = isDataNull(selectAction.from_email, 'FROMアドレス')
        if (strReturn1 !== '') {
          alert(strReturn1)
          return true
        }
        // Email-FromAddress 形式チェック
        const strReturn2 = isMailAddress(selectAction.from_email, 'FROMアドレス')
        if (strReturn2 !== '') {
          alert(strReturn2)
          return true
        }
      } else if(selectAction.type == 1) {
        // SMS-送信元 未入力チェック
        const strReturn1 = isDataNull(selectAction.from_sms_name, '送信元')
        if (strReturn1 !== '') {
          alert(strReturn1)
          return true
        }
        // SMS-送信元 形式チェック
        const strReturn2 = isSMSAddress(selectAction.from_sms_name,this.user.companySMSTEL, '送信元')
        if (strReturn2 !== '') {
          alert(strReturn2)
          return true
        }
      }
    },
    async updateRecruitmentFlowAction (selectAction) {
      if (this.isValidationUpdateRecruitmentFlowAction(selectAction)) return
      this.sendControlLog('採用フロー設定 アクション編集', '採用フロー設定にて、アクションを編集して「保存」ボタンをクリックした。')
      if (selectAction.delay_days == 0) {
        selectAction.delay_time = null
      } else {
        selectAction.hours_later = 0
      }
      try {
        await this.$store.dispatch('auth/updateRecruitmentFlowAction', selectAction)
        alert('保存しました。')
      }
      catch (e) {
        console.error(e)
        alert("エラーが発生しました。")
      }
    },
    changeEmailTemplate (templateIndex) {
      this.$set(this.sendEmailTemplate, 'name', this.emailTemplates[templateIndex].name)
      this.$set(this.sendEmailTemplate, 'from_email', this.emailTemplates[templateIndex].from_email)
      this.$set(this.sendEmailTemplate, 'cc_email', this.emailTemplates[templateIndex].cc_email)
      this.$set(this.sendEmailTemplate, 'title', this.emailTemplates[templateIndex].title)
      this.$set(this.sendEmailTemplate, 'template', this.emailTemplates[templateIndex].template)
      this.$set(this.sendEmailTemplate, 'robo', this.emailTemplates[templateIndex].robo)
      this.$set(this.sendEmailTemplate, 'video_user', this.emailTemplates[templateIndex].video_user)
      this.$set(this.sendEmailTemplate, 'record', this.emailTemplates[templateIndex].record)
      alert('テンプレートを変更いたしました。')
    },
    changeSMSTemplate (templateIndex) {
      this.$set(this.sendSMSTemplate, 'name', this.SMSTemplates[templateIndex].name)
      this.$set(this.sendSMSTemplate, 'template', this.SMSTemplates[templateIndex].template)
      this.$set(this.sendSMSTemplate, 'robo', this.SMSTemplates[templateIndex].robo)
      this.$set(this.sendSMSTemplate, 'video_user', this.SMSTemplates[templateIndex].video_user)
      this.$set(this.sendSMSTemplate, 'record', this.SMSTemplates[templateIndex].record)
      alert('テンプレートを変更いたしました。')
    },
    copyLink (cb) {
      if (!cb) {
        alert('ロボを選択してください。')
        return
      }
      this.singleURL = process.env.OWN_ENDPOINT + '/single/' + this.user.companyID + '/' + cb
      this.$nextTick(() => {
        let codeToCopy = document.querySelector('#copy-code')
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        document.execCommand('copy')
        this.$buefy.snackbar.open({
          message: 'ロボ表示URLをコピーしました！',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      })
    },
    openCloudSync () {
      this.isOpenCloudSync = true
    },

    // テーブル設定メニューを開く
    openTableSetting () {
      this.tempCompanyColumnSetting = this.companyColumnSetting
      this.isOpenTableSettingMenu = true
    },
    // 選択オプションモーダルを開く
    openSelectionOptionsModal({ columnId, columnName }) {
      this.selectedColumnId = columnId;
      this.selectedColumnName = columnName;
      this.isSelectionOptionsModalOpen = true;
    // this.$store.dispatch('auth/fetchCompanyPulldownColumns', columnId);
    },
    // 選択オプションモーダルを閉じる
    closeSelectionOptionsModal() {
      this.isSelectionOptionsModalOpen = false;
      this.selectedColumnId = null;
    },
    // 選択オプションを保存
    saveSelectionOptions(tempPulldownColumnOptions) {  // 新しく追加
      // ここでオプションを保存するロジックを実装
      console.log('Saving options:', tempPulldownColumnOptions);
      this.closeSelectionOptionsModal();
    },
    // 選択オプションの順番変更を保存
    saveOptionOrder(tempPulldownColumnOptions) {
    },
    // SelectionOptionsModalからの保存イベントを処理
    onSaveSelectionOptions(updatedOptions) {
      this.updateCompanyPulldownOptions({
        columnId: this.selectedColumnId,
        options: updatedOptions
      });
    },
    openCreateManageMenu (){
      this.isOpenCreateManageMenu = true
    },
    openFlowMenu () {
      this.isOpenFlowMenu = true
    },
    openAutoFlowMenu () {
      this.isAutoOpenFlowMenu = true
    },
    openPauseAutoFlowSetting () {
      this.isPauseAutoFlowSetting = true
    },
    openApplicantBlacklist () {
      this.isApplicantBlacklist = true
    },
    openEmailTemplate () {
      this.isOpenTemplateMenu = true
      if (this.emailTemplates.length == 0) {
        let createEmailTemplate = {
          name       : 'no title',
          from_email : '',
          to_email   : '',
          cc_email   : '',
          order_type : 0,
          template   : '',
          company    : this.user.companyPK,
          robo       : '',
        }
        this.$store.dispatch('auth/createCompanyEmailTemplate', createEmailTemplate)
      }
      if (this.SMSTemplates.length == 0) {
        let createSMSTemplate = {
          name       : 'no title',
          order_type : 0,
          template   : '',
          company    : this.user.companyPK,
          robo       : '',
          is_SMS      : true,
        }
        this.$store.dispatch('auth/createCompanySMSTemplate', createSMSTemplate)
      }
    },
    // SMS送信ゾーン開始
    showConfirmDialog(message) {
        return new Promise(resolve => {
            window.requestAnimationFrame(() => {
                const result = confirm(message)
                resolve(result)
            })
        })
    },

    showAlert(message) {
        return new Promise(resolve => {
            window.requestAnimationFrame(() => {
                alert(message)
                resolve()
            })
        })
    },

    // 元々あった送信メソッド - 非同期対応版
    async sendSMSToSeeker() {
      if (this.sendLoadding) {
        await this.showAlert('送信処理が実行中です。しばらくお待ちください。')
        return
      }

      if (this.inputSMSConfirmationTo()) return

      this.sendLoadding = true

      try {
        if (!this.sendSMSTemplate) {
          throw new Error('送信内容が設定されていません')
        }

        if (!this.bulk) {
          await this.handleIndividualSMS()
        } else {
          await this.handleBulkSMS()
        }
      } catch (error) {
        await this.handleSMSError(error)
      } finally {
        if (!this.asyncJobPollingInterval) {
          this.sendLoadding = false
          await this.updatePage()
        }
      }
    },

    // 既存の個別送信メソッド - 残す
    async handleIndividualSMS() {
      if (!this.sendSMSTemplate.seeker) {
        throw new Error('送信先が設定されていません')
      }

      const confirmed = await this.showConfirmDialog(
        'SMSをお送りします。内容にお間違いはございませんか？'
      )

      if (!confirmed) {
        await this.showAlert('キャンセルされました。')
        return
      }

      const response = await this.$store.dispatch(
        'directtalk/sendSMSToSeeker', 
        this.sendSMSTemplate
      )

      if (!response || !response.data) {
        throw new Error('サーバーからの応答が不正です')
      }

      await this.handleSMSResponse(response, false)
    },

    // 既存の一括送信メソッド - 非同期対応版
    async handleBulkSMS() {
      if (!this.bulkSeekerList || !this.bulkSeekerList.length) {
        throw new Error('送信先リストが設定されていません')
      }

      const confirmed = await this.showConfirmDialog(
        `${this.bulkSeekerList.length}件のSMSを送信します。内容にお間違いはございませんか？`
      )

      if (!confirmed) {
        await this.showAlert('キャンセルされました。')
        return
      }

      this.sendSMSTemplate.seeker = this.bulkSeekerList.map(sk => sk.id)
      this.sendSMSTemplate.to_email = ''

      const response = await this.$store.dispatch(
        'directtalk/sendSMSToSeeker',
        this.sendSMSTemplate
      )

      if (!response || !response.data) {
        throw new Error('サーバーからの応答が不正です')
      }

      // 非同期処理の場合
      if (response.data.is_async) {
        await this.startJobPolling(response.data.job_id)
        await this.showAlert('送信処理を開始しました。\n処理状況を確認しています...')
      } else {
        // 同期処理の場合は既存の処理を使用
        await this.handleSMSResponse(response, true, this.bulkSeekerList.length)
      }
    },

    // 新しい非同期ジョブのポーリング処理
    async startJobPolling(jobId) {
      this.asyncJobId = jobId
      this.asyncJobStatus = 'processing'
      
      this.asyncJobPollingInterval = setInterval(async () => {
        try {
          const response = await this.$store.dispatch('directtalk/checkSMSJobStatus', jobId)
          const jobStatus = response.data

          this.asyncJobStatus = jobStatus.status

          if (jobStatus.status === 'completed' || jobStatus.status === 'failed') {
            clearInterval(this.asyncJobPollingInterval)
            this.asyncJobPollingInterval = null
            this.sendLoadding = false
            
            if (jobStatus.status === 'completed') {
              await this.handleAsyncJobCompletion(jobStatus)
            } else {
              await this.handleAsyncJobError(jobStatus)
            }
            
            await this.updatePage()
          }
        } catch (error) {
          console.error('ジョブステータス確認エラー:', error)
          clearInterval(this.asyncJobPollingInterval)
          this.asyncJobPollingInterval = null
          this.sendLoadding = false
          await this.handleSMSError(error)
          await this.updatePage()
        }
      }, 3000)
    },
    // SMS送信レスポンスの処理
    async handleSMSResponse(response, isBulk, totalCount = 0) {

      try {
        if (!response || !response.data) {
          throw new Error('送信処理に失敗しました。')
        }

        // デフォルト値を設定
        const success_result_list = response.data.success_result_list || []
        const error_result_list = response.data.error_result_list || []
        const total_count = response.data.total_count
        const success_count = response.data.success_count
        const error_count = response.data.error_count

        // エラーメッセージの構築
        const messages = []
        const errorDetails = []

        // 送信結果のサマリー
        if (isBulk) {
          messages.push(
            '送信結果:',
            `・ 総送信数: ${total_count}件`,
            `・ 送信成功: ${success_count}件`,
            `・ 送信失敗: ${error_count}件`,
            ''
          )
        }

        // エラーの詳細な処理
        if (error_result_list.length > 0) {
          messages.push('送信できなかった宛先:')

          error_result_list.forEach(function(error) {
            let errorMessage = ''
            const telNumber = error.seeker_tel || '不明'
            const seekerName = error.seeker_name || '不明'

            switch (error.error_code) {
              case 'NO_DESTINATION':
                errorMessage = '電話番号が設定されていません'
                break
              case 'SEND_ERROR':
              case 'SEND_EXCEPTION':
                errorMessage = '送信に失敗しました'
                break
              case 'CONTENT_REPLACE_ERROR':
                errorMessage = '本文の置換に失敗しました'
                break
              case 'VALIDATION_ERROR':
                errorMessage = 'データの保存に失敗しました'
                if (error.validation_errors && error.validation_errors.message_id) {
                  // 修正前: errorMessage += (${error.validation_errors.message_id.join(', ')})
                  // 修正後:
                  errorMessage += ` (${error.validation_errors.message_id.join(', ')})`
                  // または
                  // errorMessage = `${errorMessage} (${error.validation_errors.message_id.join(', ')})`
                }
                break
              default:
                errorMessage = error.status || 'システムエラーが発生しました'
            }

            errorDetails.push(`・ ${telNumber} (${seekerName}): ${errorMessage}`)

            // エラーログの記録
            console.error('SMS送信エラー:', {
              tel: error.seeker_tel,
              name: error.seeker_name,
              status: error.status,
              error_code: error.error_code,
              validation_errors: error.validation_errors,
              timestamp: new Date().toISOString()
            })
          })

          messages.push.apply(messages, errorDetails)

          // 再試行の案内
          messages.push(
            '',
            '※ 送信に失敗した宛先があります。',
            '   しばらく時間をおいてから再度送信をお試しください。',
            '   繰り返し失敗する場合は、システム管理者にお問い合わせください。'
          )

          await this.showAlert(messages.join('\n'))
        } else {
          // 全件成功
          await this.handleSuccessResponse(isBulk, total_count)
        }
      } catch (error) {
        // システムエラーの処理
        console.error('SMS送信システムエラー:', error)

        let errorMessage = []
        if (error.response && error.response.status === 500) {
          const errorText = error.response.data && error.response.data.error 
            ? error.response.data.error 
            : '予期せぬエラーが発生しました。'

          errorMessage = [
            'システムエラーが発生しました。',
            '',
            errorText,
            '',
            '※ システム管理者にお問い合わせください。'
          ]
        } else {
          errorMessage = [
            'SMSの送信処理中にエラーが発生しました。',
            '',
            '以下をご確認ください：',
            '・送信先の電話番号が正しく設定されているか',
            '・SMS送信に必要な情報が正しく入力されているか',
            '',
            '※ 設定に問題がない場合は、しばらく時間をおいてから',
            '   再度お試しください。'
          ]
        }

        await this.showAlert(errorMessage.join('\n'))
      }
    },

    // 非同期ジョブ完了時のハンドラー
    async handleAsyncJobCompletion(jobStatus) {
      const messages = []
      
      messages.push(
        '送信結果:',
        `・総送信数: ${jobStatus.total_count}件`,
        `・送信成功: ${jobStatus.success_count}件`,
        `・送信失敗: ${jobStatus.error_count}件`
      )

      if (jobStatus.error_count > 0 && jobStatus.error_results && jobStatus.error_results.length > 0) {
        messages.push('', '送信できなかった宛先:')
        
        jobStatus.error_results.forEach(function(error) {
          const telNumber = error.seeker_tel || '不明'
          const seekerName = error.seeker_name || '不明'
          let errorMessage = ''

          switch (error.error_code) {
            case 'NO_DESTINATION':
              errorMessage = '電話番号が設定されていません'
              break
            case 'SEND_ERROR':
            case 'SEND_EXCEPTION':
              errorMessage = '送信に失敗しました'
              break
            case 'CONTENT_REPLACE_ERROR':
              errorMessage = '本文の置換に失敗しました'
              break
            case 'VALIDATION_ERROR':
              errorMessage = 'データの保存に失敗しました'
              if (error.validation_errors && error.validation_errors.message_id) {
                errorMessage += ` (${error.validation_errors.message_id.join(', ')})`
              }
              break
            default:
              errorMessage = error.status || 'システムエラーが発生しました'
          }

          messages.push(`・${telNumber} (${seekerName}): ${errorMessage}`)
        })

        messages.push(
          '',
          '※ 送信に失敗した宛先があります。',
          '   しばらく時間をおいてから再度送信をお試しください。',
          '   繰り返し失敗する場合は、システム管理者にお問い合わせください。'
        )
      } else {
        messages.push('', '全件送信完了いたしました。')
      }

      try {
        const storageKey = 'sendSMSTemplate[bulk]'
        localStorage.removeItem(storageKey)
      } catch (storageError) {
        console.error('ローカルストレージのクリア中にエラーが発生:', storageError)
      }

      await this.showAlert(messages.join('\n'))
    },

    // 非同期ジョブエラー時のハンドラー
    async handleAsyncJobError(jobStatus) {
      console.error('非同期ジョブエラー:', jobStatus.error_message)

      const errorMessage = [
        'SMS送信処理中にエラーが発生しました。',
        '',
        '処理状況:',
        `・総送信予定数: ${jobStatus.total_count}件`,
        `・処理完了数: ${jobStatus.processed_count}件`,
        `・送信成功: ${jobStatus.success_count}件`,
        `・送信失敗: ${jobStatus.error_count}件`,
        '',
        jobStatus.error_message || '予期せぬエラーが発生しました。',
        '',
        '※ しばらく時間をおいてから再度お試しください。',
        '   繰り返し失敗する場合は、システム管理者に',
        '   お問い合わせください。'
      ]

      // エラー詳細がある場合は追加
      if (jobStatus.error_results && jobStatus.error_results.length > 0) {
        errorMessage.push(
          '',
          '送信エラーが発生した宛先:'
        )

        jobStatus.error_results.forEach(function(error) {
          const telNumber = error.seeker_tel || '不明'
          const seekerName = error.seeker_name || '不明'
          const detail = error.detail || error.status || 'エラー詳細不明'
          errorMessage.push(`・${telNumber} (${seekerName}): ${detail}`)
        })
      }

      await this.showAlert(errorMessage.join('\n'))
    },

    async handleSMSError(error) {
      console.error('SMS送信エラー:', error)

      let errorMessage = []
      const hasResults = (error.error_result_list && error.error_result_list.length > 0) || 
                        (error.success_result_list && error.success_result_list.length > 0)

      if (hasResults) {
        // 送信結果のサマリーを表示
        errorMessage.push(
          '送信結果:',
          `・ 総送信数: ${error.total_count || 0}件`,
          `・ 送信成功: ${error.success_count || 0}件`,
          `・ 送信失敗: ${error.error_count || 0}件`,
          ''
        )

        // 成功リストの表示
        if (error.success_result_list && error.success_result_list.length > 0) {
          errorMessage.push('送信成功した宛先:')
          error.success_result_list.forEach(function(success) {
            errorMessage.push(`- ${success.seeker_tel || '不明'} (${success.seeker_name || '不明'})`)
          })
          errorMessage.push('')
        }

        // エラーリストの表示
        if (error.error_result_list && error.error_result_list.length > 0) {
          errorMessage.push('送信できなかった宛先:')
          error.error_result_list.forEach(function(err) {
            let detail = `- ${err.seeker_tel || '不明'} (${err.seeker_name || '不明'})`
            if (err.status) {
              detail += `: ${err.status}`
            }
            if (err.detail) {
              detail += `\n  詳細: ${err.detail}`
            }
            errorMessage.push(detail)
          })
        }
      } else {
        // 一般的なエラーメッセージ
        errorMessage.push(
          'SMSの送信処理中にエラーが発生しました。\n',
          '\n',
          '申し訳ございませんが、しばらく時間をおいてから',
          '再度送信をお試しください。',
          '\n',
          '※ 繰り返し失敗する場合は、システム管理者に',
          '   お問い合わせください。'
        )
      }

      await this.showAlert(errorMessage.join('\n'))
    },

    // 成功レスポンスの処理
    async handleSuccessResponse(isBulk, totalCount) {
      const successMessage = isBulk 
        ? `送付完了いたしました。\n全${totalCount}件の送信に成功しました。`
        : '送付完了いたしました。'

      await this.showAlert(successMessage)

      try {
        const storageKey = 'sendSMSTemplate[' + (isBulk ? 'bulk' : this.sendSMSTemplate.seeker) + ']'
        localStorage.removeItem(storageKey)
      } catch (storageError) {
        console.error('ローカルストレージのクリア中にエラーが発生:', storageError)
      }
    },

    // SMS送信ゾーン 終わり

    // ページ更新処理
    async updatePage() {
      const self = this
      if (this.$refs.manageView) {
        await new Promise(resolve => {
          self.$nextTick(resolve)
        })
        try {
          await this.$refs.manageView.pageUpdate()
        } catch (updateError) {
          console.error('ページ更新中にエラーが発生しました:', updateError)
          await this.showAlert('ページの更新中にエラーが発生しました。画面をリロードしてください。')
        }
      }
    },
    sendEmailToSeeker () {
      if (this.inputEmailConfirmationTo()) return
      this.sendLoadding = true
      // 個別のメール
      if (!this.bulk && confirm('メールをお送りします。内容にお間違いはございませんか？')) {
        this.$store.dispatch('directtalk/sendEmailToSeeker', this.sendEmailTemplate)
          .then((d) => {
            console.log('d.data.error_result_list: ', d.data.error_result_list)
            if (d.data.error_result_list.length > 0) {
              // エラーがある場合
              let errer_list = []
              for (const error of d.data.error_result_list) {
                errer_list.push('・' + error.seeker_email + ' (' + error.seeker_name + ')：[' + error.status + ']')
              }
              alert('以下のエラーが発生しました。\n\n' + errer_list.join('\n'))
            } else {
              alert('送付完了いたしました。')
              localStorage.removeItem('sendEmailTemplate'+'['+this.sendEmailTemplate.seeker+']');
              this.$refs.manageView.changeModalStageStatus(
                this.filteredSeekers.find((sk)=>sk.id==this.sendEmailTemplate.seeker),
                true)
            }
            this.sendLoadding = false
          })
          .catch(() => {
            alert('メール送付中にエラーが発生いたしました。宛先、CC等が正しいか、各種リンクが正しく選択されているか等、ご確認のほどよろしくお願いいたします。')
            this.sendLoadding = false
          })
          .finally(() => {
            this.$refs.manageView.pageUpdate()
          })
      // チェックした人全員にメール
      } else if (this.bulk && confirm('メールをお送りします。内容にお間違いはございませんか？')) {
        let sendSucessList = []
        let sendErrorList = []
        let errorMessageList = []
        for (const seeker of this.bulkSeekerList) {
          let template = {...this.sendEmailTemplate}
          template.to_email = seeker.email
          template.seeker_name = seeker.name
          template.seeker = seeker.id
          this.$store.dispatch('directtalk/sendEmailToSeeker', template)
            .then((d) => {
              for (const error of d.data.error_result_list) {
                errorMessageList.push('・' + error.seeker_email + ' (' + error.seeker_name + ')：[' + error.status + ']')
              }
              sendSucessList.push(seeker)
              localStorage.removeItem('sendEmailTemplate'+'[bulk]'); 
              this.sendLoadding = false
            })
            .catch((e) => {
              errorMessageList.push('・' + seeker.name + ' (' + seeker.email + ')：[メールの送信に失敗しました。]')
              sendErrorList.push(seeker)
              this.sendLoadding = false
            })
            .finally(() => {
              // 全件処理完了
              if (sendSucessList.length + sendErrorList.length === this.bulkSeekerList.length) {
                this.$refs.manageView.pageUpdate()
              }
              // 全て成功した場合
              if (sendSucessList.length === this.bulkSeekerList.length && errorMessageList.length <= 0) {
                alert('送付完了いたしました。')
              } else if (sendSucessList.length + sendErrorList.length === this.bulkSeekerList.length) {
                const errorList = errorMessageList.join('\n')
                alert(this.bulkSeekerList.length + '件中' + sendSucessList.length + '件が送付完了いたしました。\n以下のメールアドレスへはメールの送信ができませんでした。\n\n' + errorList)
              }
            })
        }
      // キャンセル
      } else {
        alert('キャンセルされました。')
        this.sendLoadding = false
      }
    },
    inputEmailConfirmationTo () {
      if (!this.bulk && !this.sendEmailTemplate.to_email) {
        alert('宛先（TO）が未入力です。')
        return true
      }
      if (this.bulk && !this.bulkSeekerList.length) {
        alert('宛先（TO）が未選択です。')
        return true
      }
      return false
    },
    inputSMSConfirmationTo () {
      if (!this.bulk && !this.sendSMSTemplate.to_email) {
        alert('宛先（TO）が未入力です。')
        return true
      }
      if (this.bulk && !this.bulkSeekerList.length) {
        alert('宛先（TO）が未選択です。')
        return true
      }
      return false
    },
    sendEmail (data, notOpenMenu) {
      this.sendEmailTemplate = this.$_.cloneDeep(this.emailTemplates[0])
      if (data.sk) {
        const localStrageEmailData = localStorage.getItem('sendEmailTemplate'+'['+data.sk.id+']')
        if (localStrageEmailData) {
          const obj = JSON.parse(localStrageEmailData)
          this.sendEmailTemplate.pk = obj.pk
          this.sendEmailTemplate.name = obj.name
          this.sendEmailTemplate.from_email = obj.from_email
          this.sendEmailTemplate.to_email = obj.to_email
          this.sendEmailTemplate.cc_email = obj.cc_email
          this.sendEmailTemplate.title = obj.title
          this.sendEmailTemplate.template = obj.template
          this.sendEmailTemplate.company = obj.company
          this.sendEmailTemplate.robo = obj.robo
          this.sendEmailTemplate.video_user = obj.video_user
          this.sendEmailTemplate.record = obj.record
          this.sendEmailTemplate.seeker = obj.seeker
          this.sendEmailTemplate.seeker_name = obj.seeker_name
          this.bulk = false
        } else {
          if (this.sendEmailTemplate){
            this.sendEmailTemplate.seeker = data.sk.id
            this.sendEmailTemplate.to_email = data.sk.email
            this.sendEmailTemplate.seeker_name = data.sk.name
            this.bulk = false
          }else{
            this.sendEmailTemplate = {
              name       : 'no title',
              seeker     : data.sk.id,
              from_email : '',
              to_email   : data.sk.email,
              cc_email   : '',
              order_type : this.emailTemplates.length == 0 ? 0 : Math.max(...this.emailTemplates.map((t) => t.order_type)) + 1,
              seeker_name: data.sk.name,
              title      : '',
              template   : '',
              company    : this.user.companyPK,
              robo       : ''
             }
            this.$store.dispatch('auth/createCompanyEmailTemplate', this.sendEmailTemplate)
            this.bulk = false
          }
        }
      } else if (data.bulk) {
        const localStrageEmailData = localStorage.getItem('sendEmailTemplate'+'[bulk]')
        if (localStrageEmailData) {
          const obj2 = JSON.parse(localStrageEmailData)
          this.sendEmailTemplate.from_email = obj2.from_email
          this.sendEmailTemplate.template = obj2.template
          this.sendEmailTemplate.cc_email = obj2.cc_email
          this.sendEmailTemplate.title = obj2.title
          this.sendEmailTemplate.robo = obj2.robo
          this.sendEmailTemplate.video_user = obj2.video_user
          this.sendEmailTemplate.record = obj2.record
        }
        this.sendEmailTemplate.to_email = ''
        this.bulk = true
      }     
      this.isOpenEmailMenu = (notOpenMenu ? false : true)
      if (data.bulk) {
        this.isOpenSendHistory = false;  // SendHistoryモーダルを閉じる
        this.isOpenEmailMenu = (notOpenMenu ? false : true);
      } else {
        this.isOpenEmailMenu = (notOpenMenu ? false : true);
      }
    },
    BulkManage (data, notOpenMenu) {
      this.isOpenUpdateManageMenu = (notOpenMenu ? false : true)
    },
    sendSMS (data) {
      this.sendSMSTemplate = this.$_.cloneDeep(this.SMSTemplates[0])
      if (data.sk) {
        const localStrageSMSData = localStorage.getItem('sendSMSTemplate'+'['+data.sk.id+']')
        if (localStrageSMSData) {
          const obj = JSON.parse(localStrageSMSData)
          this.sendSMSTemplate.pk = obj.pk
          this.sendSMSTemplate.name = obj.name
          this.sendSMSTemplate.from_email = obj.from_email
          this.sendSMSTemplate.to_email = obj.to_email
          this.sendSMSTemplate.cc_email = obj.cc_email
          this.sendSMSTemplate.title = obj.title
          this.sendSMSTemplate.template = obj.template
          this.sendSMSTemplate.company = obj.company
          this.sendSMSTemplate.robo = obj.robo
          this.sendSMSTemplate.video_user = obj.video_user
          this.sendSMSTemplate.record = obj.record
          this.sendSMSTemplate.seeker = obj.seeker
          this.sendSMSTemplate.seeker_name = obj.seeker_name
          this.bulk = false
        } else {
          if (this.sendSMSTemplate){
            this.sendSMSTemplate.seeker = data.sk.id
            this.sendSMSTemplate.from_email = this.user.companySMSTEL
            this.sendSMSTemplate.to_email = data.sk.tel
            this.sendSMSTemplate.seeker_name = data.sk.name
            this.bulk = false
          }else{
            this.sendSMSTemplate = {
              name       : 'no title',
              seeker     : data.sk.id,
              from_email : this.user.companySMSTEL,
              to_email   : data.sk.tel,
              cc_email   : '',
              order_type : this.SMSTemplates.length == 0 ? 0 : Math.max(...this.SMSTemplates.map((t) => t.order_type)) + 1,
              seeker_name: data.sk.name,
              title      : '',
              template   : '',
              company    : this.user.companyPK,
              robo       : ''
             }
            this.$store.dispatch('auth/createCompanySMSTemplate', this.sendSMSTemplate)
            this.bulk = false
          }
        }
      } else if (data.bulk) {
        const localStrageSMSData = localStorage.getItem('sendSMSTemplate'+'[bulk]')
        if (localStrageSMSData) {
          const obj2 = JSON.parse(localStrageSMSData)
          this.sendSMSTemplate.from_email = obj2.from_email
          this.sendSMSTemplate.template = obj2.template
          this.sendSMSTemplate.cc_email = obj2.cc_email
          this.sendSMSTemplate.title = obj2.title
          this.sendSMSTemplate.robo = obj2.robo
          this.sendSMSTemplate.video_user = obj2.video_user
          this.sendSMSTemplate.record = obj2.record
        }
        this.sendSMSTemplate.from_email = this.user.companySMSTEL
        this.sendSMSTemplate.to_email = ''
        this.bulk = true
      }     
      this.isOpenSMSMenu = true
    },
    checkbox (data) {
      this.bulkSeekerList = this.bulkSeekerList.filter(seeker => seeker.id != data.sk.id)
      if (data.isCheck === true) {
        this.bulkSeekerList.push(data.sk)
      }
    },
    checkboxAll (data) {
      if (data.isCheck === true) {
        this.$set(this, 'bulkSeekerList', data.skList)
      } else {
        this.$set(this, 'bulkSeekerList', [])
      }
      this.$forceUpdate()
    },
    sendMessage (sk) {
      this.$nextTick(function(){
        this.selectRoom(sk)
      })
    },
    selectRoom (sk) {
      if (this.isConnectRoom) {
        this.$store.dispatch('directtalk/disconnect')
      }

     var uri = process.env.WS_ENDPOINT + this.user.companyID + '/' + sk.sessionid + '/'
      this.$store.dispatch('directtalk/selectRoom', {name: sk.sessionid, skname: sk.name, group: sk.group})

      this.$store.dispatch('directtalk/connect', {uri: uri, category: 'managementtool'})
        .then (() => {
          this.$store.dispatch('directtalk/getMessage', {name: 'manager', pages: 0})
        })
      var vm = this
      setTimeout(function () {
        var rand = Math.floor(Math.random() * 9)
        vm.chatData.icon = process.env.API_ENDPOINT + '/img_s/icon/' + rand + '.png'
        var uriSpeaker = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : process.env.WDT_ENDPOINT
        uriSpeaker += '/dashboard/manage'
        vm.$store.dispatch('directtalk/setManager', uriSpeaker)
      }, 300)
    },
    loadMessage () {
      var target = document.querySelector('div.scroll-box')
      if (target.scrollTop === 0 && !this.isGetMessageMax) {
        this.isNoScroll = true
        this.$store.dispatch('directtalk/getMessage', {name: 'manager', pages: Number(this.messagePages + 1)})
      }
    },
    getTyping () {
      var idx = -1
      var vm = this
      this.roomlist.active.find(function (item, i) {
        if (item.name === vm.selectroom.name) {
          idx = i
          return i
        }
      })
      if (idx > -1) {
        if (this.roomlist.active[idx].talk === 1) {
          return '入力中です...'
        } else if (this.roomlist.active[idx].talk === 0) {
          return ''
        }
      } else {
        return ''
      }
    },
    scrollDown () {
      if (this.isNoScroll) {
        this.isNoScroll = false
        var scrollLine = document.getElementById('scrollto-' + 20)
        if (!scrollLine) return
        scrollLine.scrollIntoView(true)
      } else if (this.chatLogs.length !== 0) {
        var target = document.querySelector('div.scroll-box')
        if (!target) return
        target.scrollTop = target.scrollHeight
      }
    },
    changeModalImportSeeker (...args) {
      this.isShowModalImportSeeker = args[0]
      this.set_archiveflg = args[1]
      this.set_perpage = args[2]
      this.set_seekerspage = args[3]
      this.set_filtered = args[4]
      this.set_filter_type = args[5]
      this.set_blacklistflg = args[6]
    },
    async importSeeker (data) {
      this.isImportLoading = true

      // 1回でのインポート件数
      let splitCount = 20

      // 分割保存回数
      const importCount = Math.ceil(data.dataList.length / splitCount)

      const importData = JSON.parse(JSON.stringify(data))
      let startRow = 0
      let endRow = 0
      this.loadingTitle = '応募者インポート'
      this.loadingMessage = '応募者をインポートしています。(1/{0}件)'.format(data.dataList.length)
      this.isResponseWaiting = true
      try {
        for (let count = 0; count < importCount; count++) {
          startRow = count * splitCount
          endRow = startRow + splitCount
          if (endRow >= data.dataList.length) {
            endRow = data.dataList.length
          }
          // 保存する分だけを格納する
          const importSeekerData = data.dataList.slice(startRow, endRow)
          importData.dataList = importSeekerData
          // 分割分保存
          this.loadingMessage = '応募者をインポートしています。({0}/{1}件)'.format(endRow, data.dataList.length)
          await this.$store.dispatch('directtalk/importSeeker', importData)
            .catch((error) => {
              console.debug('error: ', error)
              throw error
            })
        }
        alert('読み込みが完了いたしました。')
      }
      catch (error) {
        console.log('error: ', error)
        alert('エラーが発生しました。')
      }
      this.isResponseWaiting = false
      this.isImportLoading = false
      this.isShowModalImportSeeker = false
      this.$store.dispatch('auth/getCompanyColumnSetting', null)
      const getSeekerConditions = {
        is_archive: this.set_archiveflg,
        is_blacklist: this.set_blacklistflg,
        filter_type: this.set_filter_type,
        filter: this.set_filtered,
        page: this.set_seekerspage,
        perPage: this.set_perpage,
        manageid: this.currentManage,
        // 2024/01/06
        // インポート後初回表示で応募者重複フラグONをデフォルトにする
        // フラグON/OFFは現在非表示なので、表示要望があった時にデフォルトをONにするかOFFにするか検討する
        // 応募者重複フラグ設定をDBに格納する場合は、その値を初期値にする (Userモデルにフィールド追加を想定)
        is_duplicate_seeker_flag: true,
        // ロボ会話履歴取得フラグ (応募者一覧を取得する場合はデフォルトtrue)
        is_get_robo_talk: true
      }
      const authUser = this.users.filter(i=>i.email === this.user.email)
      this.$store.dispatch('directtalk/getSubscribedSeekers', {conditions: getSeekerConditions, authUser: authUser, isAgent: this.user.isAgent})
    },
    displayDate(chat) {
      if (!isNaN(chat.createdAt)) {
        return new Date(chat.createdAt)
      } else {
        return new Date(chat.createdAtOther)
      }
    },
    /**
     * 媒体連携設定新規作成
     * @param {Object} tempCompanyRecruit 媒体連携設定
     */
    createCompanyRecruit (tempCompanyRecruit) {
      this.sendControlLog('外部媒体連携　登録', '外部媒体連携設定にて、「登録する」ボタンをクリックした。')
      // 重複登録チェックとデータチェック
      const checkedCompanyRecruit = this.companyRecruitCheck(tempCompanyRecruit, false)
      if (checkedCompanyRecruit === null) {
        return
      }
      // 連携設定新規作成
      tempCompanyRecruit['company'] = this.user.companyPK
      this.$store.dispatch('auth/createCompanyRecruit', tempCompanyRecruit)
      this.tempCompanyRecruit = {
        type: 0,
        rec_account_id: '',
        rec_id: '',
        rec_password: '',
        url: '',
        cp_name: '',
        update_frequency: 60,
        manage_id: [],
      }
    },
    /**
     * 媒体連携設定変更保存
     * @param {Object} companyRecruit 媒体連携設定
     */
    updateCompanyRecruit (companyRecruit) {
      this.sendControlLog('外部媒体連携　変更', '外部媒体連携設定にて、「変更する」ボタンをクリックした。')
      // 重複登録チェック
      const checkedCompanyRecruit = this.companyRecruitCheck(companyRecruit, true)
      if (checkedCompanyRecruit === null) {
        return
      }
      // 連携設定保存
      this.$store.dispatch('auth/updateCompanyRecruit', companyRecruit)
    },
    /**
     * 入力チェックと重複登録チェック
     * HRモンスター求人以外の媒体は、ログインIDおよびログインPWは入力必須
     * 既存設定の媒体を変更すると非表示項目にデータが残ったままになるので、媒体に合わせてクリアする
     * @param {Object} saveCompanyRecruit 媒体連携設定
     * @param {boolean} is_update 更新フラグ (true: 更新、false: 新規)
     * @return {Object} 媒体連携設定
     */
    companyRecruitCheck (saveCompanyRecruit, is_update) {
      // HRモンスター求人はログインIDおよびログインPWの入力チェック対象外
      if(saveCompanyRecruit.type !== 999){
        // ログインIDおよびログインPWの入力チェック
        if (!saveCompanyRecruit.rec_id || !saveCompanyRecruit.rec_password) {
          alert('ログインIDおよびログインPWは必ず入力してください。')
          return null
        }
      }

      // HRモンスター求人のみrec_idとrec_passwordをクリアする
      if (saveCompanyRecruit.type === 999) {
        saveCompanyRecruit.rec_id = ''
        saveCompanyRecruit.rec_password = ''
      }

      // rec_account_idが不要な媒体はクリアする
      if (
        // ジョブオプ
        saveCompanyRecruit.type != 7 &&
        // riksak(リクナビ)
        saveCompanyRecruit.type != 34 &&
        // RecruitingCloud
        saveCompanyRecruit.type != 61
      ) {
        // rec_account_idクリア
        saveCompanyRecruit.rec_account_id = ''
      }

      // cp_nameが不要な媒体はクリアする
      if (
        // バイトル/バイトルPRO
        saveCompanyRecruit.type != 12 &&
        // トレマッセ
        saveCompanyRecruit.type != 30 &&
        // MIWS新卒採用(マイナビ新卒)
        saveCompanyRecruit.type != 36 &&
        // Re就活
        saveCompanyRecruit.type != 48 &&
        // はたらこねっと
        saveCompanyRecruit.type != 56 &&
        // キャリアチケット
        saveCompanyRecruit.type != 64 &&
        // オファーボックス
        saveCompanyRecruit.type != 67
      ) {
        // cp_nameクリア
        saveCompanyRecruit.cp_name = ''
      }

      // urlが不要な媒体はクリアする
      if (
        // リクオプ
        saveCompanyRecruit.type != 14 &&
        // えんと～り(求人ジャーナル)
//        saveCompanyRecruit.type != 17 &&
        // トレマッセ
        saveCompanyRecruit.type != 30 &&
        // アルタスネオ
        saveCompanyRecruit.type != 41 &&
        // HITO-Manager
        saveCompanyRecruit.type != 42 &&
        // クラウドハウス
        saveCompanyRecruit.type != 43 &&
        // RecruitingCloud
        saveCompanyRecruit.type != 61 &&
        // TORUSAKU
        saveCompanyRecruit.type != 62 &&
        // JOBBASE
        saveCompanyRecruit.type != 71
      ) {
        // urlクリア
        saveCompanyRecruit.url = ''
      }
      // 重複登録チェック
      const duplicate_settings = this.companyRecruit.filter(
        data => {
          if (is_update === true) {
            // 更新の場合、
            if (data.pk === saveCompanyRecruit.pk) {
              // 同じPKの設定は重複にカウントしない
              return false
            }
          }
          // 更新間隔と応募情報振り分け先以外の設定情報が一致したら重複
          if(
            data.url === saveCompanyRecruit.url &&
            data.type === saveCompanyRecruit.type &&
            data.rec_id === saveCompanyRecruit.rec_id &&
            data.rec_password === saveCompanyRecruit.rec_password &&
            data.rec_account_id === saveCompanyRecruit.rec_account_id &&
            data.cp_name === saveCompanyRecruit.cp_name
          ) {
            return true
          }
        }
      )
      if (duplicate_settings.length > 0) {
        alert('この設定は既に登録済みです。')
        return null
      }
      return saveCompanyRecruit
    },
    deleteCompanyRecruit (companyRecruitPk) {
      this.sendControlLog('外部媒体連携　削除', '外部媒体連携設定にて、「削除する」ボタンをクリックした。')
      this.$store.dispatch('auth/deleteCompanyRecruit', companyRecruitPk)
    },
    openExportModal() {
      this.toggleExportModal(true)
    },
    toggleExportModal(isOpen) {
      this.isExportModal = isOpen
    },
    createStartOfMonth(year, month) {
      const date = new Date()
      // 月末にsetMonthで月を変更すると、日付を基準に計算されてしまう
      // なので月ごとに異なる月末日を1日にしてからsetMonthを行う
      date.setDate(1)
      date.setFullYear(year)
      date.setMonth(month - 1)
      date.setHours(0, 0, 0, 0)
      
      return date
    },
    createDateEndOfMonth(year, month) {
      const date = new Date()
      // 月末にsetMonthで月を変更すると、日付を基準に計算されてしまう
      // なので月ごとに異なる月末日を1日にしてからsetMonthを行う
      // その後にsetDateで日を設定する
      date.setDate(1)
      date.setFullYear(year)
      date.setMonth(month)
      // 指定月の最終日を取得
      date.setDate(0)
      date.setHours(23, 59, 59, 999)
      
      return date
    },
    createStartAndEndOfMonth(exportMonthFrom, exportMonthTo) {
      const monthArr1 = exportMonthFrom.split('-')
      const yearFrom = Number(monthArr1[0])
      const monthFrom = Number(monthArr1[1])
      const monthArr2 = exportMonthTo.split('-')
      const yearTo = Number(monthArr2[0])
      const monthTo = Number(monthArr2[1])
      const startOfMonth = this.createStartOfMonth(yearFrom, monthFrom)
      const endOfMonth = this.createDateEndOfMonth(yearTo, monthTo)
      return [startOfMonth, endOfMonth]
    },
    async executeCsvExport(exportMonthFrom, exportMonthTo, is_string,is_recruitpage, included_columns) {
      if (exportMonthFrom > exportMonthTo) {
        alert('期間の指定が正しくありません。')
        return
      }

      const [startOfMonth, endOfMonth] = this.createStartAndEndOfMonth(exportMonthFrom,exportMonthTo)
      const applicantFilter = this.$refs.manageView.filtered
      const filterType = this.$refs.manageView.orSwitch

      this.sendControlLog('応募者情報エクスポート', '応募者情報エクスポートを行った。')
      this.$store.dispatch('directtalk/csvExport', {
        search_start_date: startOfMonth,
        search_end_date: endOfMonth,
        manage_id: this.currentManage,
        is_string: is_string,
        is_recruitpage: is_recruitpage,
        is_blacklist: this.blacklistTab,
        applicant_filter: applicantFilter,
        filter_type: filterType,
        included_columns: included_columns
      })
    },
    helpMessage(msg) {
      this.$buefy.dialog.alert({
        message: msg,
        confirmText: "閉じる"
      });
    },
    isConfirmChatbot (chatbots) {
      let confirmChatbots = []
      for (const c of chatbots) {
        if (c.is_confirm) {
          confirmChatbots.push(c)
        }
      }
      return confirmChatbots
    },
    changeCurrentManage(changeManageId){
      return this.currentManage = changeManageId
    },
    changeBlacklistTab(flg){
      return this.blacklistTab = flg
    },
    openDetailSheetSetting() {
      this.isOpenDetailSheetSetting = true
    },
    /**
     * 応募者管理画面から遷移しようとしたときの処理
     */
    pageTransition () {
      // ページ遷移検出
      // 媒体連携項目マスターモーダルを開いたまま画面遷移する場合は、編集キャンセルと後処理を行う
      this.$refs.media_cooperation_item_master_setting.cancelEditMaster()
      this.$refs.media_cooperation_item_master_setting.modalClose()
      // 媒体連携項目マスター設定モーダルを閉じる
      this.$store.dispatch('recruitmentMedia/closeModal', 'mediaCooperationItemMaster')
      // 空のマスターデータをカレントにする
      this.$store.dispatch('recruitmentMedia/setCurrentMaster', {})
      return true
    },
    handleBlacklistDeleted() {
      // ManageViewコンポーネントのpageUpdate()メソッドを呼び出し
      this.$refs.manageView.pageUpdate()
    },
    handleBlacklistChange() {
      // ManageViewコンポーネントのpageUpdate()メソッドを呼び出し
      this.$refs.manageView.pageUpdate()
    },
    openSendHistory() {
      this.isOpenSendHistory = true;
    },
    cancelSendHistory() {
      this.isOpenSendHistory = false
    },
    handleInputClick(event) {
      event.stopPropagation();
    },
    onColorChangeStage(data, event) {
      this.$store.dispatch('auth/updateRecruitmentFlowStage', data)
      event.stopPropagation();
    },
    onColorChangeStatus(data, event) {
      this.$store.dispatch('auth/updateRecruitmentFlowStatus', data)
      event.stopPropagation();
    },
    onColorChangeAction(data, event) {
      this.$store.dispatch('auth/updateRecruitmentFlowAction', data)
      event.stopPropagation();
    },
  },
  /**
   * 親コンポーネント外または子コンポーネント内での画面遷移
   * @param  {Route} to 次のルート
   * @param  {Route} from 現在のルート
   * @param  {Function} next 次のフック
   */
  beforeRouteLeave(to, from, next) {
    if (this.modalState.mediaCooperationItemMaster === true) {
      let ret = this.pageTransition()
      next(ret)
    } else {
      next()
    }
  },
}
</script>

<style scoped lang="scss">
table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse:collapse;
  margin: 0 auto;
  display: block;
  height: calc(100% - 100px);
  table-layout: fixed;
}
tr {
  width: 100%;
}
td,th {
  padding: 8px;
  margin: auto;
  font-size: smaller;
  border-style: solid;
  border-width: 1px;
  border-color: #AA0066;
}
td {
  text-align: left;
  padding: 8px;
}
th {
  color:#fff;
  background:#AA0066;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10000;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}
.drag-button {
  height: 35px;
  background: transparent;
  border: none;
}
.container-manage {
  height: 100vh;
  width: calc(100vw - 200px);
  position: relative;
}
.container-manage-thin-menu {
  height: 100vh;
  width: calc(100vw - 55px);
  position: relative;
}
.header-box {
  width: calc(100% - 20px);
  margin: 10px 20px;
  margin-bottom: 10px;
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
  flex-wrap: wrap;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
.scroll-box {
  height: calc(100% - 110px);
  width: 100%;
}
.email-action-container {
  .to-str {
    font-size: 12px;
  }
}
.background-menu {
  height: 100%; width: 100%; background: rgba(0, 0, 0, 0.5); position: absolute; z-index: 200; top: 0;
}
.scrollable {
  padding-right: 5px;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.error-notice {
  text-align: left;
  font-size: smaller;
  font-weight: 600;
  color:red;
}
.message-notice {
  text-align: left;
  font-size: smaller;
  font-weight: 600;
}
.message-text {
  text-align: left;
  font-size: smaller;
  font-weight: 600;
}
.message-frame {
  width: 100%;
  padding: 8px;
  border: 2px solid gray;
  border-radius: 10px;
  background: rgba(255,200,200,0.4);
}
.history-button {
  background-color: #f5f5f5;
  border: 1px solid #dbdbdb;
  color: #363636;
  padding: 0.25rem 1.15rem;
  transition: all 0.2s ease;
  height: 2.25em;
  margin-right: 8px;
  font-size: 0.875rem;
}

.history-button:hover:not(:disabled) {
  background-color: #eeeeee;
  border-color: #b5b5b5;
}

.history-button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.icon-margin {
  margin-right: 5px;
  transform: rotate(-45deg);
}

</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Manage/ManageMainView.vue